import ProductLabels from "../ProductLabels";
// package block
import { useEffect, useRef, useState, Fragment } from "react";
import { isEmpty } from "lodash";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Barcode from "react-barcode";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import {
  calculateSaleDiscount,
  CONSTANT_ATTRIBUTE,
  getSaleReturnStatusType,
  formatCurrencyCustom,
  formatDate,
  getTimeByTimeZone,
  formatCurrencyCustomThree,
  sortProductsAlphabatically,
  sortCategoriesObjectKeysAlphabatically,
  getPaymentSubTypeLabel,
  getPaymentStatusName,
  getTimeByTimeZoneForTime,
  formatWithDeci,
  getKey,
} from "../../utils";
import { Col, Image } from "react-bootstrap";

import QRCode from "react-qr-code";
import { Card, Popover, Col as ColAnt, Row, Button, notification } from "antd";
import moment from "moment";
import "moment-timezone";

// custom components & values
import {
  DISCOUNT_TYPE,
  SALE_INVOICE_TYPE,
  ORDER_TYPE,
  PAYMENT_CATEGORY,
  AGING_TYPE as _AGING_TYPE,
  PAYMENT_TYPE_SALE_ORDER,
  INVOICE_STATUS,
  Units,
  ORDER_STATUS,
  SALE_TYPE,
  SALE_ORDER_PRICE_TYPE,
  SHIPPING_TYPE,
  WEIGHT_UNIT_EXPORT,
  BarcodeOnUOM,
  normalizeInvoiceHeaderTemplateId as normalizeTemplateId,
  unitLabel,
  PREFERRED_PAYMENT_METHOD,
  getNameByValue,
} from "../../../Common/constants";
import { conditionallyRender, getSettingKey, getObjectValue } from "../../../Common/utils";
import { removeCustomer } from "../../../Sale/_redux/orders/ordersActions";
import AddPaymentModal from "../payment/AddPaymentModal";

let customer = {};

// Theme 2 tab-field id for the "Remove 0 Quantity" setting. It toggles a behaviour
// (hiding 0-qty line items) rather than an invoice column, so it is excluded from
// column rendering and column counting.
const REMOVE_ZERO_QTY_FIELD_ID = "remove-0-quantity";

export default function ({
  order,
  invoiceType,
  showImage = undefined,
  showTaxes = undefined,
  showSKU,
  showBarcode = undefined,
  showCustomerBalance = undefined,
  showPrice,
  showMsrp,
  showExtCost,
  showAlternateName = undefined,
  hideInvoiceHeader = false,
  stampType,
  subtotal = undefined,
  total = undefined,
  readytoPrint = true,
  invoiceHeaderTemplate
}) {
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState({});
  const [filteredQuantity, setFilteredQuantity] = useState({});
  const handleClosePamentModal = () => setShowAddPaymentModal(false);
  const handleShowPaymentModal = () => setShowAddPaymentModal(true);
  let globalIndex = 1; // Initialize global index
  const ITEM_NO = "Item no."
  const { invoice } = order || {};
  const { payments } = invoice || {};
  const [logoImage, setLogoImage] = useState();
  const dispatch = useDispatch();
  let serialNumber = 0;
  let customerCreditCheck = false;
  const isInvoiceQuote = stampType === "quote";

  // Ensure basic settings are loaded on mount
  useEffect(() => {
    if (
      window.location.href
        .split("/")
        .find((e) => e.toLowerCase() == "sale-q-order" || e.toLowerCase() == "return" || e.toLowerCase() == "reorder" || e.toLowerCase() == "sale-order")
    ) {
      document.querySelector("body").style.overflowX = "hidden";
      const removeFlex = document.getElementById("kt_content");
      removeFlex?.classList?.remove("d-flex");
      removeFlex?.classList?.add("bg-white");
      const child = removeFlex?.children[1];
      child?.classList?.remove("d-flex");
      let removeContainer = document.getElementsByClassName("container")[0];
      !!removeContainer && removeContainer?.classList.remove("container");
      !!removeContainer && removeContainer?.classList.add("ContaineR");
      document.getElementById("kt_body")?.classList?.add("aside-hidden");
      document.getElementById("kt_header")?.classList?.add("d-none");
      document.getElementById("kt_subheader")?.classList?.add("d-none");
      document.getElementById("kt_footer")?.classList?.add("d-none");
      document.getElementById("kt_footer")?.classList?.remove("d-flex");
      if (document.getElementById("kt_wrapper")?.style) {
        document.getElementById("kt_wrapper").style.paddingTop = "0px";
      }
      document.getElementById("kt_wrapper")?.classList?.remove("wrapper");
      document.getElementById("kt_brand")?.classList?.add("d-none");
    }
    customer = { ..._customer };
    if (stampType !== "quote") {
      dispatch(removeCustomer());
    }

    return () => {
      if (stampType !== "quote") {
        document.getElementById("kt_body").classList.remove("aside-hidden");
        document.getElementById("kt_header")?.classList?.remove("d-none");
        document.getElementById("kt_subheader")?.classList?.remove("d-none");
        document.getElementById("kt_footer")?.classList?.remove("d-none");
        document.getElementById("kt_footer")?.classList?.add("d-flex");
        document.getElementById("kt_wrapper")?.classList?.add("wrapper");
        document.getElementById("kt_brand")?.classList?.remove("d-none");
        let removeContainer = document.getElementsByClassName("ContaineR")[0];
        !!removeContainer && removeContainer?.classList.add("container");
      }
    };
  }, []);
const isShowDeleiverednQuantity = ![ORDER_STATUS.PARTIALLY_EXECUTED.value].includes(order.status)
  useEffect(() => {
    setShow(showInvoiceImage());
  }, [showImage]);

  const [show, setShow] = useState(true);
  const { currentBasicState, currentOrder } = useSelector(
    (state) => ({
      currentBasicState: state?.basicSettings,
      currentOrder: state?.orders,
      currentDisplayState: state?.basicSettings.entity.Invoice,
    }),
    shallowEqual
  );
  const [isInvoiceThemeTypeEnabled, setIsInvoiceThemeTypeEnabled] = useState(currentBasicState?.entity?.Basic?.invoice_theme_type || "theme1");
  // Force re-render when basic settings change (including theme changes)
  useEffect(() => {
    if (currentBasicState?.entity?.Basic?.invoice_theme_type !== undefined) {
      setIsInvoiceThemeTypeEnabled(currentBasicState?.entity?.Basic?.invoice_theme_type);
    }
  }, [currentBasicState?.entity?.Basic?.invoice_theme_type]);

  const currentDisplayState = getSettingKey(currentBasicState?.entity, "Invoice");
  const PosSettings = getSettingKey(currentBasicState?.entity, "POS");
  const immutableBasicSettings = getSettingKey(currentBasicState?.entity, "IMMUTABLE_BASIC");
  const adminPanelSettings = immutableBasicSettings["admin-panel"];

  // These all the attributes coming from settings which we were saved in sale attributes
  let attributes;
  try {
    attributes = PosSettings?.attributes.filter((item) => item.display_invoice);
  } catch (err) {
    attributes = [];
  }

  const { bill_to, customer_details, order_details, payment_detials, product_details, ship_to, total_amount_details } = currentDisplayState;
  const tab_fields = getSettingKey(currentBasicState?.entity, "Invoice", "tab_fields") || [];
  const product_details_inputs = getSettingKey(currentBasicState?.entity, "Invoice", "product_details_inputs") || {};
  const payment_tab_fields = getSettingKey(currentBasicState?.entity, "Invoice", "payment_tab_fields") || [];
  const payment_details_inputs = getSettingKey(currentBasicState?.entity, "Invoice", "payment_details_inputs") || {};

  // Get visible tab fields sorted by order for non-theme1 layouts
  const visibleTabFields = tab_fields.filter((field) => field.visible).sort((a, b) => a.order - b.order);
  const orderedVisibleTabFields = (() => {
    const fields = [...visibleTabFields];
    
    // If product_details.is_product_desc is enabled, ensure the description field is included
    if (product_details?.is_product_desc) {
      const hasDescField = fields.some((f) => f.id === "is_product_desc");
      if (!hasDescField) {
        // Create the description field if it doesn't exist
        const descField = {
          id: "is_product_desc",
          title: "Description",
          field_key: "is_product_desc",
          visible: true,
          order: 2, // Will be repositioned right after name
        };
        fields.push(descField);
      }
    }
    
    // Reorder to place description right after name
    const nameIndex = fields.findIndex((f) => f.id === "name");
    const descIndex = fields.findIndex((f) => f.id === "is_product_desc");
    
    if (nameIndex >= 0 && descIndex >= 0 && descIndex !== nameIndex + 1) {
      const [descField] = fields.splice(descIndex, 1);
      fields.splice(nameIndex + 1, 0, descField);
    }
    
    return fields;
  })();

  // Get visible payment tab fields sorted by order for non-theme1 layouts
  const visiblePaymentTabFields = payment_tab_fields.filter((field) => field.visible).sort((a, b) => a.order - b.order);

  const isTotalColumnField = (fieldId) => fieldId === "total" || fieldId === "ext-price";
  const getPaymentDisplayDate = (payment) =>
    payment.payment_type === PAYMENT_TYPE_SALE_ORDER.ACH.value
      ? payment.schedule_date
      : payment.payment_date;
  const isProductDetailFieldEnabled = (field) =>
    isTotalColumnField(field.id) ? product_details?.Extended || product_details?.Total_Without_Discount : product_details?.[field.field_key];

  const getSelectedUnitUpc = (item) => {
    const selectedUnit = Number(item?.unit);
    const getUnitUpc = (unitPrices) => {
      if (Array.isArray(unitPrices)) {
        return unitPrices.find(
          (unitPrice) => Number(unitPrice?.unit) === selectedUnit
        )?.upc;
      }

      return (
        unitPrices?.[selectedUnit]?.upc ||
        Object.values(unitPrices || {}).find(
          (unitPrice) => Number(unitPrice?.unit) === selectedUnit
        )?.upc
      );
    };

    return (
      getUnitUpc(item?.product?.unit_prices) ||
      getUnitUpc(item?.unit_prices) ||
      item?.product?.upc ||
      item?.upc ||
      ""
    );
  };
  const isPromotionPrice = (item) => item.price_type === SALE_ORDER_PRICE_TYPE.PROMOTION_PRICE || item.reward_detail_id;
  // Helper function to render table header based on field
  const renderTableHeader = (field) => {
    const { id, title } = field;
    // "Remove 0 Quantity" is a behaviour flag, not a column, so it never renders a header
    if (id === REMOVE_ZERO_QTY_FIELD_ID) return null;
    // Skip fields that should be hidden based on props or conditions
    if (id === "image" && showImage) return null;
    if ((id === "sku" || id === "upc-number" || id === "barcode" || id === "retail-upc" || id === "box-upc" || id === "unit-upc") && showSKU) return null;
    if (id === "barcode" && showBarcode) return null;
    if ((id === "supply-price" || id === "net-sale-price" || id === "unit-price") && showPrice) return null;
    if (id === "msrp" && showMsrp) return null;
    if ((id === "total" || id === "ext-price") && showExtCost) return null;
    if (id === "return-type" && !isReturned) return null;
    if(id==="delivered-quantity" && isShowDeleiverednQuantity) return null;
    if(id==="remaining-quantity" && isShowDeleiverednQuantity) return null;
    // Check if field is enabled in product_details
    if (!isProductDetailFieldEnabled(field)) return null;

    // Special handling for split taxes
    if (id === "split-taxes" && product_details?.Split_Taxes) {
      return uniqueTaxTypes.map((taxType, index) => (
        <th key={`tax-header-${index}`} className="table-product-qty-size second-subheading hide-at-tab hide-at-tab2">
          {taxType}
        </th>
      ));
    }

    // Get appropriate CSS class based on field type
    const getHeaderClass = () => {
      switch (id) {
        case "sr-no":
          return "table-product-sr-size second-subheading hide-at-tab hide-at-tab2";
        case "image":
          return "table-product-image-size second-subheading";
        case "name":
          return "table-product-name-size second-subheading";
        case "is_product_desc":
          return "table-product-other-size second-subheading";
        case "sku":
          return "table-product-sku-size second-subheading hide-at-tab hide-at-tab2";
        case "qty":
        case "order-qty":
          return "table-product-qty-size second-subheading text-center";
        case "supply-price":
        case "net-sale-price":
        case "unit-price":
        case "msrp":
          return "table-product-price-size second-subheading";
        case "total":
        case "ext-price":
          return "table-product-other-size second-subheading text-center";
        default:
          return "table-product-other-size second-subheading hide-at-tab hide-at-tab2";
      }
    };

    // Use custom input value as column name if available, otherwise use default title
    const displayTitle = (showAlternateName && id === "sku") ? ITEM_NO : product_details_inputs[id] || title;
    

    return (
      <th key={id} className={getHeaderClass()}>
        {displayTitle}
        {id === "net-sale-price" && " (" + currencySymbol + ")"}
        {id === "unit-price" && " (" + currencySymbol + ")"}
      </th>
    );
  };

  // Helper function to render table cell based on field
  const renderTableCell = (field, item, taxValues) => {
    const { id } = field;

    // "Remove 0 Quantity" is a behaviour flag, not a column, so it never renders a cell
    if (id === REMOVE_ZERO_QTY_FIELD_ID) return null;
    // Skip fields that should be hidden based on props or conditions
    if (id === "image" && showImage) return null;
    if ((id === "sku" || id === "upc-number" || id === "barcode" || id === "retail-upc" || id === "box-upc" || id === "unit-upc") && showSKU) return null;
    if (id === "barcode" && showBarcode) return null;
    if ((id === "supply-price" || id === "net-sale-price" || id === "unit-price") && showPrice) return null;
    if (id === "msrp" && showMsrp) return null;
    if ((id === "total" || id === "ext-price") && showExtCost) return null;
    if (id === "return-type" && !isReturned) return null;
    if (id === "delivered-quantity" && isShowDeleiverednQuantity ) return null;
    if (id === "remaining-quantity" && isShowDeleiverednQuantity ) return null;
    // Check if field is enabled in product_details
    if (!isProductDetailFieldEnabled(field)) return null;

    // Special handling for split taxes
    if (id === "split-taxes" && product_details?.Split_Taxes) {
      return uniqueTaxTypes.map((taxType, index) => {
        const taxAmount = taxValues?.find(({ tax }) => tax?.name === taxType)?.amount || 0;
        return (
          <td key={`tax-cell-${index}`} className="table-product-other-size product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
            {taxAmount > 0 ? `${currencySymbol}${formatCurrencyCustomThree(taxAmount)}` : "-"}
          </td>
        );
      });
    }

    // Get appropriate CSS class based on field type
    const getCellClass = () => {
      switch (id) {
        case "sr-no":
          return "table-product-sr-size text pl-2 hide-at-tab hide-at-tab2";
        case "image":
          return "table-product-image-size hide-at-mobil";
        case "name":
          return "table-product-name-size product-text";
        case "sku":
          return "table-product-sku-size product-text hide-at-tab hide-at-tab2";
        case "qty":
        case "order-qty":
          return "table-product-qty-size product-text text-center";
        case "barcode":
          return "table-product-barcode-col";
        case "supply-price":
        case "net-sale-price":
        case "unit-price":
        case "msrp":
          return "table-product-price-size product-text";
        case "total":
        case "ext-price":
          return "table-product-other-size align-center product-text";
        default:
          return "table-product-other-size product-text hide-at-tab hide-at-tab2";
      }
    };

    const cellStyle = { breakInside: "avoid" };
    if (id === "image") cellStyle.paddingTop = "9px";

    // Render cell content based on field type
    const renderCellContent = () => {
      switch (id) {
        case "sr-no":
          return ++serialNumber;

        case "image":
          return (
            <div className="symbol symbol-60 flex-shrink-0">
              <Popover
                zIndex={2000}
                content={<img src={`${item.product?.images?.[0] || item?.images?.[0] || ""}`} width={"120px"} alt="Product Image" />}
                title=""
                trigger="hover"
              >
               <img src={item.product?.images?.[0] || item?.images?.[0]} />
              </Popover>
            </div>
          );

        case "name":
          return (
            <div>
              <span>
                <h1
                  style={{
                    fontSize: `${Font_Size}px`,
                    fontWeight: "700",
                    margin: "auto",
                    padding: "0",
                  }}
                >
                  {(showAlternateName && (item.product?.alternate_name || item?.alternate_name)) ? (item.product?.alternate_name || item?.alternate_name) : item.product?.name || item?.name}
                </h1>
                <ProductLabels tags={item.product?.tags || item.tags} screen="invoice" />
              </span>
              {(isPromotionPrice(item)) && (
                <Image className="ml-2 bg-white rounded border-0" src={toAbsoluteUrl("/media/logos/promo-sale-badge.jpg")} width={"40px"} />
              )}
            </div>
          );

        case "is_product_desc":
          return <div className="text-break">{getProductDescription(item)}</div>;

        case "sku":
          return showAlternateName ? (item?.product?.id || item.id) : (item.product?.sku || item?.sku);

        case "qty":
          return Math.floor(isInvoiceQuote ? item?.quantity : (item.qty ?? item?.quantity));

        case "order-qty":
          return item?.order_qty ?? "-";

        case "barcode":
          return item.product?.upc || item?.upc ? (
            <Barcode
              value={product_details_inputs?.["Theme2barcode_on_uom"] === BarcodeOnUOM.SOLD_BY_UOM && item?.product?.unit_prices?.find((unitPrice) => unitPrice.unit === item?.unit)?.upc ? item.product.unit_prices.find((unitPrice) => unitPrice.unit === item?.unit).upc : item.product?.upc || item?.upc}
              displayValue={false}
              height={25}
              background={globalIndex % 2 === 0 ? "#ecf0f3" : "#fff"}
            />
          ) : null;

        case "upc-number":
          return getSelectedUnitUpc(item);

        case "retail-upc":
          return item.product?.retail_upc1 || item?.retail_upc1 || "";

        case "unit":
          // The Unit Desc frozen on the line at sale time, else the tier name.
          return unitLabel(item.unit, item?.unit_name);

         case "supply-price":
          return (
            <>
              <div>{currencySymbol}{formatCurrencyCustom(item?.newPrice || item.unit_price)}</div> 
              {(isPromotionPrice(item))  && order.sale_type !== SALE_TYPE.SALE_RETURN.value  && (
                <div style={{ textDecoration: 'line-through' }}>
                 {product_details.strike_through ? `${currencySymbol}${formatCurrencyCustom(item?.product?.unit_prices?.["0"]?.price)}` : null}
                </div>
              )}
            </>
          );

        case "net-sale-price":
          return item?.qty || item?.quantity
            ? `${currencySymbol}${formatCurrencyCustomThree(
                (item?.newPrice || item.unit_price) +
                  taxValues?.map(({ amount }) => amount).reduce((total, amount) => total + amount, 0) / (item?.qty || item?.quantity)
              )}`
            : `${currencySymbol}0.00`;

        case "msrp":
          return `${currencySymbol}${formatCurrencyCustom(item?.msrp_price)}`;

        case "discount":
          return `${item?.discount_type == DISCOUNT_TYPE.FIXED ? currencySymbol : ""}${item?.discount ? item?.discount : 0}${item?.discount_type == DISCOUNT_TYPE.PERCENTAGE ? "%" : ""}`;

        case "tax":
          return `${currencySymbol}${
            (item?.qty || item?.quantity) && taxValues?.length
              ? formatCurrencyCustomThree(taxValues?.map(({ amount }) => amount).reduce((total, amount) => total + amount, 0))
              : 0
          }`;

        case "total":
        case "ext-price":
          return `${currencySymbol}${formatCurrencyCustom(getItemTotal(item, taxValues, product_details?.Total_Without_Discount)).toLocaleString()}`;

        case "box-upc":
          return item?.unit_prices?.[item?.unit]?.upc || item?.selected_unit_prices?.upc || "";

        case "size":
          return (item?.unit_prices?.[item?.unit]?.lowest_unit_definition || item?.lowest_unit_definition || 0) * (item?.qty || item?.quantity || 0);

        case "unit-price":
          return `${currencySymbol}${formatCurrencyCustom(item?.product?.unit_prices?.["0"]?.price || item?.unit_prices?.["1"]?.price || 0)}`;

        case "unit-upc":
          return item?.product?.unit_prices?.["0"]?.upc || item?.unit_prices?.["1"]?.upc || "";

        case "return-type":
          return getSaleReturnStatusType(item?.return_to_stock);

        case "delivered-quantity":
            return Math.floor(item?.delivered_qty || 0);

        case "remaining-quantity":
            return Math.floor((item?.qty || item?.quantity || 0) - (item?.delivered_qty || 0));
        default:
          return "";
      }
    };
    return (
      <td key={id} className={getCellClass()} style={cellStyle}>
        {renderCellContent()}
      </td>
    );
  };

    const getTheme2TotalColumnCount = () => {
    let count = 0;

    orderedVisibleTabFields.forEach((field) => {
      const { id } = field;

      // "Remove 0 Quantity" is a behaviour flag, not a column, so it must not be counted
      if (id === REMOVE_ZERO_QTY_FIELD_ID) return;
      // Skip fields that should be hidden based on props or conditions
      if (id === "image" && showImage) return;
      if ((id === "sku" || id === "upc-number" || id === "barcode" || id === "retail-upc" || id === "box-upc" || id === "unit-upc") && showSKU) return;
      if (id === "barcode" && showBarcode) return;
      if ((id === "supply-price" || id === "net-sale-price" || id === "unit-price") && showPrice) return;
      if (id === "msrp" && showMsrp) return;
      if ((id === "total" || id === "ext-price") && showExtCost) return;
      if (id === "return-type" && !isReturned) return;

      // Check if field is enabled in product_details
      if (!isProductDetailFieldEnabled(field)) return;

      // Count split taxes separately
      if (id === "split-taxes" && product_details?.Split_Taxes) {
        count += uniqueTaxTypes.length;
      } else if (id === "is_product_desc") {
        count++;
      } else {
        count++;
      }
    });

    return count;
  };
  const renderCategoryRowCell = (items, filteredProducts, filteredQuantity) => {
  // Calculate total column count
  const showParentCategory = product_details?.Parent_Category || !Object.hasOwn(product_details, "Parent_Category");
  const showTotalQty = product_details?.Total_Qty || !Object.hasOwn(product_details, "Total_Qty");
  const showExtended = (product_details?.Total_Without_Discount || product_details?.Extended) && !showExtCost;

  return (
    <td
      colSpan={getTheme2TotalColumnCount()}
      className="align-left cat-size total_category"
      style={{ padding: "10px" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        {/* Left side - Category Name */}
        <div>
          {showParentCategory && (
            <strong>
              {`${items === "Misc_Items" ? "Misc. item(s)" : ""} ${items.charAt(0).toUpperCase() + items.slice(1)}`}
              {filteredProducts[items].categoriesAssociated.length ? (
                <span> ({filteredProducts[items].categoriesAssociated.join(", ")})</span>
              ) : null}
            </strong>
          )}
        </div>

        {/* Right side - Qty and Total */}
        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
          {showTotalQty && (
            <strong>
              <span style={{ marginLeft: "0.5em" }}>Qty:</span> <span>{filteredQuantity[items]}</span>
            </strong>
          )}
          {showExtended && (
            <strong>
              Total: {currencySymbol}
              {formatCurrencyCustom(filteredProducts[items]?.extendedPrice)}
            </strong>
          )}
        </div>
      </div>
    </td>
  );
};

  // Helper function to render payment table header based on field
  const renderPaymentTableHeader = (field) => {
    const { id, title, field_key } = field;

    // Check if field is enabled in payment_detials
    if (!payment_detials?.[field_key]) return null;

    // Get appropriate CSS class based on field type
    const getHeaderClass = () => {
      switch (id) {
        case "sr-no":
          return "second-subheading hide-at-tab";
        case "payment-type":
          return "second-subheading";
        case "reference-no":
          return "second-subheading hide-at-mobile";
        case "payment-category":
          return "second-subheading hide-at-mobile";
        case "payment-date":
          return "second-subheading hide-at-mobile";
        case "aging-type":
          return "second-subheading hide-at-mobile";
        case "amount":
          return "second-subheading";
        case "is-cleared":
          return "second-subheading";
        case "payment-amount":
          return "second-subheading";
        case "applied-amount":
          return "second-subheading";
        case "credit-amount":
          return "second-subheading";
        case "payment-id":
          return "second-subheading hide-at-mobile";
        case "payment-status":
          return "second-subheading";
        default:
          return "second-subheading";
      }
    };

    // Use custom input value as column name if available, otherwise use default title
    const displayTitle = payment_details_inputs[id] || title;

    return (
      <th key={id} className={getHeaderClass()}>
        {displayTitle}
      </th>
    );
  };

  // Helper function to render payment table cell based on field
  const renderPaymentTableCell = (field, item, idx) => {
    const { id, field_key } = field;

    // Check if field is enabled in payment_detials
    if (!payment_detials?.[field_key]) return null;

    // Get appropriate CSS class based on field type
    const getCellClass = () => {
      switch (id) {
        case "sr-no":
          return "text hide-at-tab";
        case "payment-type":
          return "product-text";
        case "reference-no":
          return "product-text hide-at-mobile";
        case "payment-category":
          return "product-text hide-at-mobile";
        case "payment-date":
          return "product-text hide-at-mobile";
        case "aging-type":
          return "product-text hide-at-mobile";
        case "amount":
          return "product-text";
        case "is-cleared":
          return "product-text";
        case "payment-amount":
          return "product-text";
        case "applied-amount":
          return "product-text";
        case "credit-amount":
          return "product-text";
        case "payment-id":
          return "product-text hide-at-mobile";
        case "payment-status":
          return "product-text";
        default:
          return "product-text";
      }
    };

    // Render cell content based on field type
    const renderCellContent = () => {
      switch (id) {
        case "sr-no":
          return Object.keys(PAYMENT_TYPE_SALE_ORDER).map((salePayment) => {
            if (PAYMENT_TYPE_SALE_ORDER[salePayment].value == item.payment_type)
              return PAYMENT_TYPE_SALE_ORDER[salePayment].type == "Customer Credit Added" ? null : ++serialNumber;
          });

        case "payment-type":
          return Object.keys(PAYMENT_TYPE_SALE_ORDER).map((salePayment) => {
            if (PAYMENT_TYPE_SALE_ORDER[salePayment].value === item.payment_type) {
              const isCustomerCreditAdded = PAYMENT_TYPE_SALE_ORDER[salePayment].type === "Customer Credit Added";
              customerCreditCheck = isCustomerCreditAdded;

              const paymentSubTypeLabel = getPaymentSubTypeLabel(item.payment_sub_type);

              return (
                <span
                  style={{
                    fontSize: isCustomerCreditAdded ? "fontsize-8" : "inherit",
                    fontStyle: isCustomerCreditAdded ? "italic" : "normal",
                  }}
                >
                  {isCustomerCreditAdded ? (
                    `- ${PAYMENT_TYPE_SALE_ORDER[salePayment].type}`
                  ) : (
                    <>
                      {PAYMENT_TYPE_SALE_ORDER[salePayment].type}
                      {(PAYMENT_TYPE_SALE_ORDER[salePayment].type === "Credit/Debit Card" || PAYMENT_TYPE_SALE_ORDER[salePayment].type === "Cheque") &&
                        paymentSubTypeLabel &&
                        ` / ${paymentSubTypeLabel}`}
                    </>
                  )}
                </span>
              );
            }
          });

        case "reference-no":
          return item?.reference_number ? item?.reference_number : "";

        case "payment-category":
           return Object.keys(PAYMENT_CATEGORY).map((category) => {
                                  if (PAYMENT_CATEGORY[category].value === item.category) {
                                    return PAYMENT_CATEGORY[category].type;
                                  }
                                })[0] || "";
        case "payment-date":
          return formatDate(getTimeByTimeZone(timezone, getPaymentDisplayDate(item)));

        case "aging-type":
          return ""; // This might need specific logic based on your requirements

        case "amount":
          return `$${item?.paid_amount || "0"}`;

        case "is-cleared":
          return item.is_cleared ? "True" : "False";

        case "payment-amount":
          return `$${item?.paid_amount || "0"}`;

        case "applied-amount":
          return `$${item?.applied_amount || "0"}`;

        case "credit-amount":
          return `$${item?.remaining_amount || "0"}`;

        case "payment-id":
          return item.no || "";
        case "delivered-quantity":
          return item.delivered_qty || "";

        case "remaining-quantity":
          return item.qty - item.delivered_qty || "";
        case "payment-status":
          return getPaymentStatusName(item.status) || "";

        default:
          return "";
      }
    };

    return (
      <td key={id} className={getCellClass()}>
        {renderCellContent()}
      </td>
    );
  };

  const { state_id_licence_expiry, show_tobacco_certificate_expiry, show_business_certificate_expiry, show_resale_certificate_expiry } = customer_details;
  const { Invoice_memo, Font_Size } = product_details || {};
  const { AGING_TYPE: invoiceAgingType, signature_align_right } = order_details || {};
  const dateFormat = "YYYY-MM-DD";
  const currencySymbol = getSettingKey(currentBasicState.entity, "Basic", "currency_symbol");
  const tanantData = getSettingKey(currentBasicState.entity, "Basic");
  const invoiceHeaderTemplates = Array.isArray(tanantData?.invoice_header_templates) ? tanantData.invoice_header_templates : [];
  const selectedTemplateId = normalizeTemplateId(
    order?.invoice_setting?.invoice_header_template_id ?? tanantData?.selected_invoice_header_template_id ?? invoiceHeaderTemplate?.id
  );
  const selectedTemplateFromSettings = invoiceHeaderTemplates.find(({ id }) => normalizeTemplateId(id) === selectedTemplateId);
  const selectedInvoiceHeaderTemplate =
    invoiceHeaderTemplate && normalizeTemplateId(invoiceHeaderTemplate.id) === selectedTemplateId ? invoiceHeaderTemplate : selectedTemplateFromSettings;
  const tenantInvoiceLogo = selectedInvoiceHeaderTemplate
    ? selectedInvoiceHeaderTemplate.tenant_invoice_logo
    : getSettingKey(currentBasicState.entity, "Basic", "tenant_invoice_logo");

  const tenantInvoiceDetails =
    selectedInvoiceHeaderTemplate?.tenant_invoice_details ||
    tanantData?.tenant_invoice_details ||
    getSettingKey(currentBasicState.entity, "Basic", "tenant_invoice_details");

  const tenantInvoiceDescription =
    selectedInvoiceHeaderTemplate?.dist_message ||
    tanantData?.dist_message ||
    getSettingKey(currentBasicState.entity, "Basic", "dist_message");

  const paymentType = getSettingKey(currentBasicState.entity, "POS", "payment_types");
  const orderTypes = getSettingKey(currentBasicState.entity, "POS", "order_types");
  const invoiceImage = getSettingKey(currentBasicState.entity, "Basic", "invoice_image");
  const timezone = getSettingKey(currentBasicState.entity, "Basic", "timezone");
  const { customer: _customer } = currentOrder;
console.log(currentBasicState.entity);

  const getItemQuantity = (item) => Number(isInvoiceQuote ? item?.quantity : item?.qty ?? item?.quantity ?? 0);
  const getItemPrice = (item) => Number(isInvoiceQuote ? item?.newPrice : item?.unit_price || item?.newPrice || 0);
  const getItemTaxTotal = (taxValues = []) => taxValues?.map(({ amount }) => Number(amount) || 0).reduce((total, amount) => total + amount, 0) || 0;
  const getItemDiscountTotal = (item) => {
    const itemPrice = getItemPrice(item);
    const itemQty = getItemQuantity(item);
    const discount = Number(item?.discount) || 0;

    if (!discount) return 0;
    if (item?.discount_type == DISCOUNT_TYPE.FIXED) return discount * itemQty;

    return itemPrice * itemQty * (discount / 100);
  };
  const getItemTotal = (item, taxValues = [], withoutDiscount = false) => {
    const grossTotal = getItemPrice(item) * getItemQuantity(item) + getItemTaxTotal(taxValues);
    return withoutDiscount ? grossTotal : grossTotal - getItemDiscountTotal(item);
  };
  const visibleInvoiceProducts = Object.values(filteredProducts || {}).flatMap(({ products = [] }) => products);
  const visibleInvoiceProductCount = visibleInvoiceProducts.length;
  const visibleInvoiceQuantity = visibleInvoiceProducts.reduce((sum, product) => sum + getItemQuantity(product), 0);

  // Calculate unique tax types for split taxes
  const [uniqueTaxTypes, setUniqueTaxTypes] = useState([]);

  useEffect(() => {
    const _filteredProducts = {};
    const _filteredQuantity = {};
    const _uniqueTaxTypesSet = new Set();

    for (let i = 0; i < order.sale_order_details?.length; i++) {
      const product = order.sale_order_details[i];
      let totalTax = 0;

      // "Remove 0 Quantity" invoice setting: hide line items with no quantity
      if (product_details?.Remove_0_Quantity && !getItemQuantity(product)) continue;

      if (product?.qty || product?.quantity) {
        let taxValues = product?.tax_values?.length
          ? product.tax_values.map(({ calculatedTax, value, tax_attribute_id, tax_id, taxName, tax_attribute_name }) => {
              return { amount: calculatedTax, value, tax: { id: tax_id, name: taxName }, tax_attribute: { id: tax_attribute_id, name: tax_attribute_name } };
            })
          : product?.sale_order_detail_taxes?.length
            ? product?.sale_order_detail_taxes
            : [];
        totalTax = taxValues?.map(({ amount }) => amount).reduce((total, amount) => total + amount, 0) || 0;

        // Collect unique tax types for split taxes
        if (product_details?.Split_Taxes) {
          taxValues?.forEach(({ tax, amount }) => {
            if (amount > 0 && tax?.name) {
              _uniqueTaxTypesSet.add(tax.name);
            }
          });
        }
      }

      const extendedPrice = getItemTotal(product, [{ amount: totalTax }], product_details?.Total_Without_Discount);
      const mainCategory = product.product?.main_category?.name || product.main_category_name;
      const catagoryName = product.product?.root_category || product.product?.main_category?.name || product.main_category_name || "NULL";
      if (!!catagoryName && !product?.is_misc) {
        if (!!_filteredProducts[catagoryName]?.products) {
          _filteredProducts[catagoryName]["products"].push(product);
          _filteredProducts[catagoryName]["extendedPrice"] += isNaN(extendedPrice) || !extendedPrice ? 0 : extendedPrice;

          ![_filteredProducts[catagoryName]["categoriesAssociated"], catagoryName].includes(mainCategory) &&
            _filteredProducts[catagoryName]["categoriesAssociated"].includes(mainCategory);
          _filteredQuantity[catagoryName] += Number(isInvoiceQuote ? product.quantity : (product.qty ?? product.quantity));
        } else {
          _filteredProducts[catagoryName] = { products: [product], extendedPrice, categoriesAssociated: mainCategory != catagoryName ? [mainCategory] : [] };
          _filteredQuantity[catagoryName] = Number(isInvoiceQuote ? product.quantity : (product.qty ?? product.quantity));
        }
      }

      if (!!product?.is_misc) {
        if (!!_filteredProducts["Misc_Items"]?.products) {
          _filteredProducts["Misc_Items"]["products"].push(product);
          _filteredProducts["Misc_Items"]["extendedPrice"] += extendedPrice;
          _filteredQuantity["Misc_Items"] += Number(isInvoiceQuote ? product.quantity : (product.qty ?? product.quantity));
        } else {
          _filteredProducts["Misc_Items"] = { products: [product], extendedPrice, categoriesAssociated: [] };
          _filteredQuantity["Misc_Items"] = Number(isInvoiceQuote ? product.quantity : (product.qty ?? product.quantity));
        }
      }
    }

    setFilteredProducts((prev) => _filteredProducts);
    setFilteredQuantity((prev) => _filteredQuantity);

    // Set unique tax types for split taxes
    if (product_details?.Split_Taxes) {
      setUniqueTaxTypes(Array.from(_uniqueTaxTypesSet));
    }
  }, [order.sale_order_details, order.sale_order_details?.length, subtotal, product_details?.Total_Without_Discount, product_details?.Remove_0_Quantity]);

  useEffect(() => {
    setLogoImage(undefined);

    if (!tenantInvoiceLogo) return;

    let isCurrentLogo = true;

    fetch(tenantInvoiceLogo)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (isCurrentLogo) {
            setLogoImage(reader.result);
          }
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error("Error fetching image:", error);
      });

    return () => {
      isCurrentLogo = false;
    };
  }, [tenantInvoiceLogo]);

  const showInvoiceImage = () => {
    if (showImage !== undefined) {
      if (!showImage) {
        if (product_details?.Image) {
          return true;
        }
      }
    } else {
      if (!invoiceImage && product_details?.Image) {
        return true;
      }
    }
    return false;
  };

  const Note = ({ note, label }) => (
    <>
      <div className="heading hr mt-2"></div>
      <table>
        <tbody className="product-text">
          <div className="d-flex">
            <b className="mr-2">{label}:</b>
            <div className="text-break">
              <p>{note}</p>
            </div>
          </div>
        </tbody>
      </table>
    </>
  );

  function calculateDays(dueDateStr, orderDateStr) {
    const dueDate = new Date(dueDateStr);
    const orderDate = new Date(orderDateStr);

    // Calculate the difference in days
    const timeDifferenceInDays = moment(dueDate, dateFormat).diff(moment(orderDate).startOf("day"), "days");

    return timeDifferenceInDays;
  }
  //waterMark
  const isOrderParked = ORDER_STATUS.PARKED.value == order.status;
  const isInvoiceDue = [INVOICE_STATUS.DRAFT.value, INVOICE_STATUS.DUE.value, INVOICE_STATUS.UN_PAID.value, INVOICE_STATUS.PARTIALLY_PAID.value].includes(
    order?.invoice?.status
  );
  const isReturned = order.sale_type === SALE_TYPE.SALE_RETURN.value;
  const image = {
    true: "/media/logos/return3.png",
    false: "/media/logos/paid13.png",
    Void: "/media/logos/void.jpg",
    quote: "/media/logos/quote_stamp.png",
    // draft: "/media/logos/draft.png",
  };

  const watermarkStyle = {
    backgroundImage: `url(${toAbsoluteUrl(
      order.invoice?.status === INVOICE_STATUS.VOID.value
        ? image.Void
        : stampType == "quote"
          ? image.quote
          : isReturned.toString()
            ? image[isReturned.toString()]
            : image[isInvoiceDue.toString()]
    )})`,
  };

  let Invoicestatus = order?.invoice?.status;
  let isInvoiceUnpaid = Invoicestatus === 2;
  let isInvoiceDueForPayment = Invoicestatus === 1;
  let isInvoicePartiallyPaid = Invoicestatus === 5;

  useEffect(() => {
    try {
      var iOS = !!navigator?.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      if ((iOS || navigator?.userAgentData?.mobile) && (isInvoiceUnpaid || isInvoiceDueForPayment || isInvoicePartiallyPaid)) {
        setShowAddPaymentModal(true);
      }
    } catch (error) {
      console.error(error);
    }
  }, [order]);

  const certificateValidator =
    customer_details?.show_resale_certificate ||
    customer_details?.show_business_certificate ||
    customer_details?.show_tobacco_certificate ||
    customer_details?.state_id_licence ||
    customer_details?.other_certificates;
  const stateIdLicenceCheck = customer_details?.state_id_licence && (order?.customer?.state_id_license_num || order?.customer?.state_id_license_expiry);
  const tobaccoLicenceCheck = customer_details?.show_tobacco_certificate && (order?.customer?.tobacco_license_num || order?.customer?.tobacco_license_expiry);
  const businessLicencCheck =
    customer_details?.show_business_certificate && (order?.customer?.business_certificate_num || order?.customer?.business_certificate_expiry);
  const resaleLicenceCheck =
    customer_details?.show_resale_certificate && (order?.customer?.resale_certificate_num || order.customer?.resale_certificate_expiry);
  const otherLicenceCheck =
    customer_details?.other_certificates && order?.customer?.customer_other_licenses && order?.customer?.customer_other_licenses.length > 0;
  const otherLicenceExpiryCheck = customer_details?.other_certificates_expiry;
  const allCertificateValidator = stateIdLicenceCheck || tobaccoLicenceCheck || businessLicencCheck || resaleLicenceCheck || otherLicenceCheck;
  // Function to convert time to the specified timezone
  const convertTimeToTimezone = (order, timezone) => {
    const created_at = order.created_at;
    return getTimeByTimeZone(timezone, created_at, "YYYY-MM-DD, HH:mm:ss")?.split ? getTimeByTimeZoneForTime(timezone, created_at)?.split("T")[1] : "";
  };

  const orderBillingDetail = order?.billing_detail;
  const customerBillingDetails = order?.customer?.customer_billing_details;
  const convertedTime = convertTimeToTimezone(order, timezone);
  const customerBillingCity = orderBillingDetail?.city || customerBillingDetails?.city;
  const customerBillingAddress = orderBillingDetail?.address || customerBillingDetails?.address;
  const customerBillingAddressLine1 = orderBillingDetail?.address ? orderBillingDetail?.address_line_1 : customerBillingDetails?.address_line_1;
  const customerBillingZipCode = orderBillingDetail?.zip_code || customerBillingDetails?.zip_code;
  const customerBillingAddressCheck = !!orderBillingDetail?.address || !!customerBillingDetails?.address;
  const customerBillingState = orderBillingDetail?.state || customerBillingDetails?.state;
  const customerBillingCounty = orderBillingDetail?.county || customerBillingDetails?.county;
  const customerBillingCountry = orderBillingDetail?.country || customerBillingDetails?.country;

  const ShowFlatTaxes = ({ name, amount }) => (
    <li className="d-flex justify-content-between">
      <span className="second-subheading">{name}</span>
      <span className="product-text">
        {currencySymbol}
        {formatCurrencyCustomThree(amount)}
      </span>
    </li>
  );

  const placeHolderTd = <td className="table-product-qty-size product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}></td>;

  const getInvoiceStatusName = (statusValue) => {
    const statusesToShow = [INVOICE_STATUS.DRAFT, INVOICE_STATUS.UN_PAID, INVOICE_STATUS.PAID, INVOICE_STATUS.PARTIALLY_PAID];
    const status = statusesToShow.find((status) => status.value === statusValue);
    return status ? status.name : "";
  };

  const invoiceStatusName = getInvoiceStatusName(order?.invoice?.status);

  const timeZoneRef = useRef();
  useEffect(() => {
    timeZoneRef.current = timezone;
  }, [timezone]);

  function getDisplayName(item, showAlternateName) {
    const alternate = item.product?.alternate_name || item?.alternate_name;
    const name = item.product?.name || item?.name;

    if (showAlternateName && alternate) {
      return alternate;
    }

    return name;
  }

  function getProductDescription(item) {
    const desc = item?.product?.description || item?.product?.product_unit_description || item?.description || item?.product_description || "";
    // Strip HTML tags and return plain text
    const plainText = desc.replace(/<[^>]*>/g, "");
    return plainText;
  }

  const getTotalColumnCount = () => {
    let count = 0;

    if (product_details?.Sr_No) count++;
    if (product_details?.Image && !showImage) count++;
    if (product_details?.Name) count++;
    if (product_details?.Qty) count++;
    if (product_details?.show_order_qty) count++;
    if (product_details?.is_product_desc) count++;
    if (product_details?.SKU && !showSKU) count++;
    if (product_details?.UPC_Number && !showSKU) count++;
    if ((product_details?.RETAIL_UPC ?? true) && !showSKU) count++;
    if (product_details?.UPC_Barcode && !showBarcode) count++;
    if (product_details?.Unit) count++;
    if (isReturned && product_details?.return_to_stock) count++;
    if (product_details?.Supply_Price && !showPrice) count++;
    if (product_details?.Net_Sale_Price && !showPrice) count++;
    if (product_details?.msrp_price && !showMsrp) count++;
    if (product_details?.Discount) count++;
    if (product_details?.Delivered_Quantity && ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) && [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(order.status))
      count++;
    if (product_details?.Remaining_Quantity && ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) && [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(order.status))
      count++;
    if (product_details?.Taxes) count++;
    if (product_details?.Split_Taxes) count += uniqueTaxTypes.length;
    if ((product_details?.Total_Without_Discount || product_details?.Extended) && !showExtCost) count++;

    return count;
  };

  // show payment details
  const showPaymentSerialNo = payment_detials?.Sr_No || !Object.hasOwn(payment_detials, "Sr_No");
  const showPaymentType = payment_detials?.Payment_Type || !Object.hasOwn(payment_detials, "Payment_Type");
  const showPaymentReferenceNo = payment_detials?.reference_no || !Object.hasOwn(payment_detials, "reference_no");
  const showPaymentId = payment_detials?.Payment_ID || !Object.hasOwn(payment_detials, "Payment_ID");

  const showPaymentDate = payment_detials?.Payment_Date || !Object.hasOwn(payment_detials, "Payment_Date");
  const showPaymentAmount = payment_detials?.Payment_Amount || !Object.hasOwn(payment_detials, "Payment_Amount");
  const showPaymentAppliedAmount = payment_detials?.Applied_Amount || !Object.hasOwn(payment_detials, "Applied_Amount");
  const showPaymentCreditAmount = payment_detials?.Credit_Amount || !Object.hasOwn(payment_detials, "Credit_Amount");
  const showPaymentStatus = payment_detials?.Status || !Object.hasOwn(payment_detials, "Status");
  const showPaymentTerms = payment_detials?.Payment_Terms || !Object.hasOwn(payment_detials, "Payment_Terms");
  const showPreferredPaymentMethod =
    payment_detials?.show_preferred_payment_method || !Object.hasOwn(payment_detials || {}, "show_preferred_payment_method");
  const showPreferredCarrier = ship_to?.show_preferred_carrier || !Object.hasOwn(ship_to || {}, "show_preferred_carrier");

  const showPaymentSection = showPaymentSerialNo || showPaymentType || showPaymentReferenceNo || showPaymentId || showPaymentDate || showPaymentAmount || showPaymentAppliedAmount || showPaymentCreditAmount || showPaymentStatus || showPaymentTerms

function toCamelCase(str) {
    if (!str) return "";
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

  if (!!order?.invoice) {

    return (
      <div
        className="sale-invoice-responsive"
        style={{
          pageBreakAfter: "always",
        }}
      >
        {!hideInvoiceHeader ? (
          <div className="p-0 m-0">
            <table width="100%">
              <tbody className="divHeader">
                <tr>
                  <div fluid={true}>
                    {order_details?.invoice_promotion_banner_check && tanantData?.invoice_promotion_banner && (
                      <div className="invoice-card mb-3">
                        <div style={{ width: "15px" }}></div>
                        <img src={tanantData?.invoice_promotion_banner} className="w-100 h-auto fill" />
                      </div>
                    )}
                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                      className="invoice-card"
                    >
                      <ColAnt md={4} lg={2} sm={2}>
                        <div className="invoice-logo">
                          <td>
                            {(logoImage || tenantInvoiceLogo) && (
                              <div
                                style={{
                                  display: "block",
                                  color: "white",
                                  marginLeft: "auto",
                                  backgroundImage: `url(${logoImage || tenantInvoiceLogo})`,
                                  backgroundSize: "contain",
                                  backgroundRepeat: "no-repeat",
                                }}
                                className="logo-save-invoice invoice-logo"
                              />
                            )}
                          </td>
                        </div>
                      </ColAnt>
                      <ColAnt sm={readytoPrint ? 19 : 24} xs={readytoPrint ? 7 : 24} md={12} lg={17}>
                        <>
                          <div className="qr-flex">
                            <span
                              className="product-text-2 text-left tenant-invoice-details"
                              dangerouslySetInnerHTML={{
                                __html: tenantInvoiceDetails,
                              }}
                            />
                            <Col md={3} lg={3} className="hide-qr-main">
                              <div style={{ height: "auto", margin: "auto", maxWidth: 350, width: "100%", breakInside: "avoid" }}>
                                <QRCode
                                  size={350}
                                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                  value={`${window?.location?.origin}/sale/invoice/${order?.peculiar_no}`}
                                  viewBox={`0 0 350 350`}
                                />
                              </div>
                            </Col>
                          </div>
                        </>
                      </ColAnt>
                      <ColAnt sm={readytoPrint ? 3 : 24} xs={readytoPrint ? 7 : 24} md={5} lg={5} className="d-none d-sm-block scan-to-pay-column">
                        <div className="d-flex flex-column float-right">
                          <div className="scan-to-pay">
                            <p>Scan to Pay</p>
                          </div>
                          <div className="qr-code">
                            <QRCode
                              size={350}
                              style={{ height: "auto", maxWidth: "100%", width: "150px" }}
                              value={`${window?.location?.origin}/sale/invoice/${order?.peculiar_no}?pk=${immutableBasicSettings?.public_key || adminPanelSettings?.immutable_basic?.public_key}`}
                              viewBox={`0 0 350 350`}
                            />
                          </div>
                          {(isInvoiceUnpaid || isInvoiceDueForPayment || isInvoicePartiallyPaid) && (
                            <Button onClick={handleShowPaymentModal} className="ant-btn btn-info d-none d-lg-block button-text mt-2">
                              Add Payment
                            </Button>
                          )}
                        </div>
                      </ColAnt>
                    </Row>

                    <Row
                      gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                      }}
                      className="invoice-card"
                    >
                      {order_details?.Invoice_no || customer_details?.Customer_number || order_details?.Order_type ? (
                        <ColAnt sm={readytoPrint ? 7 : 24} xs={readytoPrint ? 7 : 24} md={8} lg={6}>
                          <table className="table-size">
                            <tbody>
                              <>
                                {order_details?.Invoice_no && (
                                  <tr>
                                    <td className="second-subheading">{stampType === "quote" ? "Quotation No" : "SO#:"}</td>
                                    <td className="product-text">{order.no}</td>
                                  </tr>
                                )}

                                {customer_details?.Customer_number && stampType !== "quote" && (
                                  <tr>
                                    <td className="second-subheading">Cus No: &nbsp;</td>
                                    <td className="product-text">{order?.customer?.no ? order?.customer?.no : "-"}</td>
                                  </tr>
                                )}

                                {order_details?.Order_type && (
                                  <tr>
                                    <td width="40%" className="second-subheading">
                                      Order Type:
                                    </td>
                                    <td className="product-text" width="60%">
                                      {getObjectValue(orderTypes, order.order_type)}
                                      {order.order_type == ORDER_TYPE.OTHER.value ? ` (${order.other_type_value})` : null}
                                    </td>
                                  </tr>
                                )}
                              </>
                            </tbody>
                          </table>
                        </ColAnt>
                      ) : null}

                      {(order.sale_type === 1 && order_details?.Due_date) || order_details?.Order_by ? (
                        <ColAnt sm={readytoPrint ? 7 : 24} xs={readytoPrint ? 7 : 24} md={8} lg={6}>
                          <table className="table-size">
                            <tbody>
                              {order.sale_type === 1 && order_details?.Due_date && (
                                <tr>
                                  <td className="second-subheading">Time:</td>
                                  <td className="product-text">
                                    {stampType === "quote" ? (
                                      <>{order?.storage_name}</>
                                    ) : (
                                      <div>
                                        {convertedTime}, {timeZoneRef?.current?.abbrev}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              )}
                              {order.sale_type === 1 && order_details?.Due_date && (
                                <tr>
                                  <td className="second-subheading">Inv Due Dt:</td>
                                  <td className="product-text">{formatDate(getTimeByTimeZone(timezone, order?.invoice?.due_date))}</td>
                                </tr>
                              )}
                              {order_details?.Order_by && (
                                <tr>
                                  <td className="second-subheading">Created by:</td>
                                  <td className="product-text" width="60%">
                                    {[null, "", "null"].includes(order?.created_by?.id)
                                      ? order?.customer?.business_name
                                      : `${order?.created_by?.first_name}  
                              ${order?.created_by?.last_name}`}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </ColAnt>
                      ) : null}
                      {(order_details?.Order_date && stampType !== "quote") ||
                      (order.sale_type === 1 && order_details?.Status) ||
                      order_details?.sale_agent_name ? (
                        <ColAnt sm={readytoPrint ? 7 : 24} xs={readytoPrint ? 7 : 24} md={8} lg={6}>
                          <table className="table-size">
                            <tbody>
                              {order_details?.Order_date && stampType !== "quote" && (
                                <tr>
                                  <td className="second-subheading">Order Date:</td>
                                  <td className="product-text" width="60%">
                                    {getTimeByTimeZone(timezone, order.order_date, "MM/DD/YYYY")?.split("T")[0]}
                                  </td>
                                </tr>
                              )}
                              {order.sale_type === 1 && order_details?.Status && (
                                <tr>
                                  <td className="second-subheading">Inv Status:</td>
                                  <td className="product-text">
                                    {order.invoice?.status == INVOICE_STATUS.DRAFT.value ? <strong>{invoiceStatusName}</strong> : invoiceStatusName}
                                  </td>
                                </tr>
                              )}
                              {order_details?.sale_agent_name && (order?.sale_rep?.id || order.saleAgent?.value)? (
                                <tr>
                                  <td className="second-subheading">Sales Rep.:</td>
                                  <td className="product-text" width="60%">
                                    {order.sale_rep?.username || order.saleAgent?.label ||  ""}
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                        </ColAnt>
                      ) : null}
                    </Row>
                  </div>
                </tr>
              </tbody>
            </table>
            <table className="table-size mt-4">
              <tbody>
                <tr>
                  {/* <div className="d-flex invoice-change-into-column"> */}
                  <Row
                    gutter={{
                      xs: 8,
                      sm: 16,
                      md: 24,
                      lg: 32,
                    }}
                  >
                    {/* All these conditions for short time as we are updating invoice from BE side so we gonna remove it in next phase */}
                    {bill_to?.Bill_Business_name || bill_to?.Name || bill_to?.Email || bill_to?.Phone_no ? (
                      <ColAnt md={12} lg={8} sm={readytoPrint ? 8 : 24} xs={readytoPrint ? 8 : 24}>
                        <table>
                          <tbody>
                            <tr>
                              <td className="invoice-heading heading hr">Bill To</td>
                            </tr>
                            {bill_to?.Bill_Business_name ? (
                              <tr>
                                <td className="second-subheading" style={{width:"90px"}}>Business:</td>
                                <td className="product-text">{order?.customer?.business_name ? order?.customer?.business_name : "-"}</td>
                              </tr>
                            ) : null}
                            {bill_to?.Name ? (
                              <tr>
                                <td className="second-subheading" style={{width:"90px"}}>Customer:</td>
                                <td className="product-text">{customerBillingDetails?.name || "-"}</td>
                              </tr>
                            ) : null}
                            {bill_to?.Email ? (
                              <tr>
                                <td className="second-subheading" style={{width:"90px"}}>Email:</td>
                                <td className="product-text address-email">{order?.customer?.email ? order?.customer?.email : "-"}</td>
                              </tr>
                            ) : null}
                            {bill_to?.Phone_no ? (
                              <tr>
                                <td className="second-subheading" style={{width:"90px"}}>Phone:</td>
                                <td className="product-text">
                                  {conditionallyRender(orderBillingDetail?.telephone_num || customerBillingDetails?.telephone_num, "-")}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                        {bill_to?.Address && (
                          <tr >
                            {" "}
                            <td className="second-subheading" style={{width:"90px"}}>Address:</td>
                           <td className="product-text" style={{ minWidth: "110px" }}>
                                {customerBillingAddressCheck
                                  ? [
                                      customerBillingAddress,
                                      customerBillingAddressLine1,
                                      toCamelCase(customerBillingCity),
                                      toCamelCase(customerBillingCounty),
                                      toCamelCase(customerBillingState),
                                      customerBillingCountry,
                                      customerBillingZipCode,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")
                                  : "-"}
                              </td>
                          </tr>
                        )}
                      </ColAnt>
                    ) : null}
                    { (() => {
                        const isPickupOrder = order.shipping_type === SHIPPING_TYPE.PICKUP.value;
                        const hasShipToFields =
                          !isPickupOrder &&
                          (ship_to?.Ship_Business_name || ship_to?.Name || ship_to?.Email || ship_to?.Phone_no || ship_to?.Address);
                        const hasPreferredCarrier =
                          showPreferredCarrier && (order?.customer?.preferred_carrier_name || order?.customer?.preferred_carrier);
                        return hasShipToFields || hasPreferredCarrier ? (
                          <ColAnt md={12} lg={8} sm={readytoPrint ? 8 : 24} xs={readytoPrint ? 8 : 24}>
                            <>
                              <table>
                                <tbody>
                                  <tr>
                                    <td className="invoice-heading heading hr">Ship To</td>
                                  </tr>
                                  {!isPickupOrder && ship_to?.Ship_Business_name ? (
                                    <tr>
                                      <td className="second-subheading" style={{width:"90px"}}>Business:</td>
                                      <td className="product-text">{order?.customer?.business_name || "-"}</td>
                                    </tr>
                                  ) : null}
                                  {!isPickupOrder && ship_to?.Name && (
                                    <tr>
                                      <td className="second-subheading" style={{width:"90px"}}>Customer:</td>
                                      <td className="product-text">{conditionallyRender(order?.shipping_detail?.name, "-")}</td>
                                    </tr>
                                  )}
                                  {!isPickupOrder && ship_to?.Email && (
                                    <tr>
                                      <td className="second-subheading" style={{width:"90px"}}>Email:</td>
                                      <td className="product-text address-email">{order?.customer?.email ? order?.customer?.email : "-"}</td>
                                    </tr>
                                  )}
                                  {!isPickupOrder && ship_to?.Phone_no && (
                                    <tr>
                                      <td className="second-subheading" style={{width:"90px"}}>Phone:</td>
                                      <td className="product-text">{conditionallyRender(order?.shipping_detail?.telephone_num, "-")}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              {!isPickupOrder && ship_to?.Address && (
                                <div>
                                  {" "}
                                  <span className="second-subheading" style={{width:"90px"}}>Address:</span>
                                 <span  className="product-text" style={{ minWidth: "110px" }}>
                                  {!!order?.shipping_detail?.address
                                    ? [
                                        toCamelCase(order.shipping_detail.address),
                                        toCamelCase(order.shipping_detail.address_line_1),
                                        toCamelCase(order.shipping_detail.city),
                                        toCamelCase(order.shipping_detail.county),
                                        toCamelCase(order.shipping_detail.state),
                                        toCamelCase(order.shipping_detail.country),
                                        toCamelCase(order.shipping_detail.zip_code),
                                      ]
                                        .filter(Boolean)
                                        .join(", ")
                                    : "-"}
                                </span>
                                </div>
                              )}
                              {hasPreferredCarrier && (
                                <div>
                                  {" "}
                                  <span className="second-subheading" style={{width:"90px"}}>Pref. Carrier: </span>
                                  <span className="product-text" style={{ minWidth: "110px" }}>
                                    {order?.customer?.preferred_carrier_name || order?.customer?.preferred_carrier}
                                  </span>
                                </div>
                              )}
                            </>
                          </ColAnt>
                        ) : null;
                      })()
                    }
                    {order?.customer?.id &&
                      order.sale_type == SALE_TYPE.SALE_ORDER.value &&
                      customer_details?.show_customer_liscenses &&
                      certificateValidator &&
                      allCertificateValidator && (
                        <ColAnt md={12} lg={8} sm={readytoPrint ? 8 : 24} xs={readytoPrint ? 8 : 24}>
                          <table>
                            <tbody>
                              <tr>
                                <td className="invoice-heading heading hr">Licenses</td>
                              </tr>
                              {resaleLicenceCheck && (
                                <tr>
                                  <td className="second-subheading" width={"30%"}>
                                    Resale:
                                  </td>
                                  <td className="product-text">
                                    {order?.customer?.resale_certificate_num || ""}{" "}
                                    {order?.customer?.resale_certificate_num &&
                                      order?.customer?.resale_certificate_expiry &&
                                      show_resale_certificate_expiry &&
                                      "/"}{" "}
                                    {show_resale_certificate_expiry && order?.customer?.resale_certificate_expiry
                                      ? formatDate(getTimeByTimeZone(timezone, order?.customer?.resale_certificate_expiry))
                                      : ""}
                                    {!order.customer?.resale_certificate && show_resale_certificate_expiry && <span className="text-danger">*</span>}
                                  </td>
                                </tr>
                              )}
                              {businessLicencCheck && (
                                <tr>
                                  <td className="second-subheading">Business:</td>
                                  <td className="product-text">
                                    {order?.customer?.business_certificate_num || ""}{" "}
                                    {order?.customer?.resale_certificate_num &&
                                      order?.customer?.resale_certificate_expiry &&
                                      show_business_certificate_expiry &&
                                      "/"}{" "}
                                    {show_business_certificate_expiry && order?.customer?.business_certificate_expiry
                                      ? formatDate(getTimeByTimeZone(timezone, order?.customer?.business_certificate_expiry))
                                      : ""}
                                    {!order.customer?.business_certificate && show_business_certificate_expiry && <span className="text-danger">*</span>}
                                  </td>
                                </tr>
                              )}
                              {tobaccoLicenceCheck && (
                                <tr>
                                  <td className="second-subheading">Tobacco:</td>
                                  <td className="product-text">
                                    {order?.customer?.tobacco_license_num || ""}{" "}
                                    {order?.customer?.resale_certificate_num &&
                                      order?.customer?.resale_certificate_expiry &&
                                      show_tobacco_certificate_expiry &&
                                      "/"}{" "}
                                    {show_tobacco_certificate_expiry && order?.customer?.tobacco_license_expiry
                                      ? formatDate(getTimeByTimeZone(timezone, order?.customer?.tobacco_license_expiry))
                                      : ""}
                                    {!order.customer?.tobacco_license && show_tobacco_certificate_expiry && <span className="text-danger">*</span>}
                                  </td>
                                </tr>
                              )}
                              {stateIdLicenceCheck && (
                                <tr>
                                  <td className="second-subheading">ID :</td>
                                  <td className="product-text">
                                    {order?.customer?.state_id_license_num || ""}{" "}
                                    {order?.customer?.state_id_license_num && order?.customer?.state_id_license_expiry && state_id_licence_expiry && "/"}{" "}
                                    {state_id_licence_expiry && order?.customer?.state_id_license_expiry
                                      ? formatDate(getTimeByTimeZone(timezone, order?.customer?.state_id_license_expiry))
                                      : ""}
                                    {!order.customer?.state_id_license && state_id_licence_expiry && <span className="text-danger">*</span>}
                                  </td>
                                </tr>
                              )}
                              {otherLicenceCheck &&
                                order?.customer?.customer_other_licenses?.map(({ expiry_date, id, number }) => (
                                  <tr key={id}>
                                    <td className="second-subheading">Others:</td>
                                    <td className="product-text">
                                      {number || "-"}{" "}
                                      {otherLicenceExpiryCheck ? `/ ${number ? formatDate(getTimeByTimeZone(timezone, expiry_date)) : "-"} ` : ""}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </ColAnt>
                      )}
                  </Row>
                </tr>
              </tbody>
            </table>

            {!isEmpty(order?.external_note) && Invoice_memo && (
              <>
                {
                  <>
                    <div className="heading hr mt-2"></div>
                    <table>
                      <tbody className="product-text">
                        <div className="d-flex">
                          <b className="mr-2">{"Notes"}:</b>
                          <div className="text-break">
                            <p>{order.external_note}</p>
                          </div>
                        </div>
                      </tbody>
                    </table>
                  </>
                }
              </>
            )}

            {!isEmpty(order?.note) && (
              <>
                <Note note={order.note} label={"Customer Notes"} />
              </>
            )}
          </div>
        ) : null}
        {order.sale_order_details?.length > 0 ? (
          <div className="products center-img">
            {isOrderParked || isInvoiceDue ? null : (
              <div
                className={`bg-image ${!hideInvoiceHeader ? "bg-image-center-with-header" : "bg-image-center-no-header"}  printWaterMark`}
                style={{
                  ...watermarkStyle,
                  marginTop: order.invoice?.status === INVOICE_STATUS.DRAFT.value ? "8%" : "",
                }}
              />
            )}
            {isInvoiceThemeTypeEnabled ? (
              <table className={`hide-invoice-table items-table table-size ${product_details?.Grid_Lines && "border-product"}`} style={{ zIndex: "1" }}>
                <thead className="table-active">
                  {isInvoiceThemeTypeEnabled == "theme1" ? (
                    <tr id="productList" className="">
                      {product_details?.Sr_No && <th className="table-product-sr-size second-subheading hide-at-tab hide-at-tab2">Sr.No</th>}
                      {product_details?.Image && !showImage && <th className="table-product-image-size second-subheading">Image</th>}
                      {product_details?.Name && (
                        <th id="productName" className="table-product-name-size second-subheading">
                          Name
                        </th>
                      )}
                      {product_details?.is_product_desc && (
                        <th className="table-product-other-size second-subheading">
                         Product Description
                        </th>
                      )}
                      {product_details?.show_order_qty && (
                        <th id="order_qty" className="table-product-qty-size second-subheading text-center">
                          Order Qty
                        </th>
                      )}
                      {product_details?.Qty && (
                        <th id="qty" className="table-product-qty-size second-subheading text-center">
                          Sold Qty
                        </th>
                      )}
                      {product_details?.SKU && !showSKU && (
                        <th className="table-product-sku-size second-subheading hide-at-tab hide-at-tab2">{showAlternateName ? ITEM_NO : "SKU"}</th>
                      )}
                      {product_details?.UPC_Number && !showSKU && (
                        <th className="table-product-other-size second-subheading hide-at-tab hide-at-tab2">UPC Number</th>
                      )}
                      {(product_details?.RETAIL_UPC ?? true) && !showSKU && (
                        <th className="table-product-other-size second-subheading hide-at-tab hide-at-tab2">Retail UPC</th>
                      )}
                      {product_details?.UPC_Barcode && !showBarcode && <th className="table-product-other-size second-subheading pl-3">Barcode</th>}
                      {product_details?.Unit && <th className="table-product-qty-size second-subheading hide-at-tab hide-at-tab2">Unit</th>}
                      {isReturned && product_details?.return_to_stock && <th className="table-product-other-size second-subheading">Return Type</th>}
                      {product_details?.Supply_Price && !showPrice && (
                        <th id="price" className="table-product-price-size second-subheading">
                          Price
                        </th>
                      )}
                      {product_details?.Net_Sale_Price && !showPrice && (
                        <th id="price" className="table-product-price-size second-subheading">
                          Net Sale Price
                        </th>
                      )}
                      {product_details?.msrp_price && !showMsrp && (
                        <th id="price" className="table-product-price-size second-subheading">
                          MSRP
                        </th>
                      )}
                      {product_details?.Discount && <th className="table-product-other-size second-subheading hide-at-tab hide-at-tab2">Disc.</th>}
                      {product_details?.Delivered_Quantity &&
                        ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                        [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(order.status) && (
                          <th className="table-product-other-size second-subheading">Delivered Qty</th>
                        )}
                      {product_details?.Remaining_Quantity &&
                        ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                        [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(order.status) && (
                          <th className="table-product-other-size second-subheading">Remaining Qty</th>
                        )}
                      {product_details?.Taxes && <th className="table-product-qty-size second-subheading hide-at-tab hide-at-tab2">Tax</th>}
                      {/* Split Tax Headers */}
                      {product_details?.Split_Taxes &&
                        uniqueTaxTypes.map((taxType, index) => (
                          <th key={`tax-header-${index}`} className="table-product-qty-size second-subheading hide-at-tab hide-at-tab2">
                            {taxType}
                          </th>
                        ))}
                      {(product_details?.Total_Without_Discount || product_details?.Extended) && !showExtCost && (
                        <th className="table-product-other-size second-subheading text-center">Total</th>
                      )}
                    </tr>
                  ) : (
                    <tr id="productList" className="">
                      {orderedVisibleTabFields.map((field) => renderTableHeader(field)).filter(Boolean)}
                    </tr>
                  )}
                </thead>
                <tbody className="text">
                  {sortCategoriesObjectKeysAlphabatically(filteredProducts)?.map((items, key) => (
                    <Fragment key={key}>
                      {/* Wrote sort method lines to sort out all products alphabetically */}
                      {sortProductsAlphabatically(filteredProducts[items].products).map((item, key) => {
                        const taxValues = item?.tax_values?.length
                          ? item?.tax_values.map(({ value, calculatedTax, tax_attribute_id, tax_attribute_name, taxName, tax_id }) => {
                              return {
                                amount: calculatedTax,
                                value,
                                tax: { id: tax_id, name: taxName },
                                tax_attribute: { id: tax_attribute_id, name: tax_attribute_name },
                              };
                            })
                          : item.sale_order_detail_taxes?.length
                            ? item.sale_order_detail_taxes
                            : [];
                        return (
                          <>
                            {isInvoiceThemeTypeEnabled == "theme1" ? (
                              <tr
                                key={"item" + item?.id + item?.name}
                                className={`back-order-row ${
                                  ![ORDER_STATUS.COMPLETED.value, ORDER_STATUS.EXECUTED.value].includes(order.status) &&
                                  item?.product?.transferable_qty === 0 &&
                                  item?.product?.back_order_portal
                                    ? "pink-background"
                                    : "white-background"
                                }`}
                                style={{
                                  breakInside: "avoid",
                                }}
                              >
                                {product_details?.Sr_No && (
                                  <td className="table-product-sr-size text pl-2 hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {globalIndex++}
                                  </td>
                                )}
                                {product_details?.Image && !showImage && (
                                  <td className="table-product-image-size hide-at-mobil" style={{ paddingTop: "9px", breakInside: "avoid" }}>
                                    <div className="symbol symbol-60 flex-shrink-0">
                                      {item.product?.images?.[0] || item?.images?.[0] ? (
                                        <Popover
                                          zIndex={2000}
                                          content={<img src={`${item.product?.images?.[0] || item?.images?.[0] || ""}`} width={"120px"} alt="Product Image" />}
                                          title=""
                                          trigger="hover"
                                        >
                                          <img src={item.product?.images?.[0] || item?.images?.[0]} />
                                        </Popover>
                                      ) : null}
                                    </div>
                                  </td>
                                )}
                                {product_details?.Name && (
                                  <td className="table-product-name-size product-text" style={{ breakInside: "avoid" }}>
                                    <div>
                                      <span>
                                        <h1
                                          style={{
                                            fontSize: `${Font_Size}px`,
                                            fontWeight: "700",
                                            margin: "auto",
                                            padding: "0",
                                          }}
                                        >
                                          {getDisplayName(item, showAlternateName)}
                                          <ProductLabels tags={item.product?.tags || item.tags} screen="invoice" />
                                          {(isPromotionPrice(item))  && (
                                        <Image
                                          className="ml-2 bg-white rounded border-0"
                                          src={toAbsoluteUrl("/media/logos/promo-sale-badge.jpg")}
                                          width={"40px"}
                                        />
                                      )}
                                        </h1>
                                      </span>

                                    </div>
                                  </td>
                                )}
                                {product_details?.is_product_desc && (
                                  <td className="table-product-other-size product-text" style={{ breakInside: "avoid" }}>
                                    <div className="text-break">{item?.product?.product_unit_description}</div>
                                  </td>
                                )}
                                {product_details?.show_order_qty && (
                                  <td className="table-product-qty-size product-text text-center" style={{ breakInside: "avoid" }}>
                                    {item?.order_qty ?? "-"}
                                  </td>
                                )}
                                {product_details?.Qty && (
                                  <td className="table-product-qty-size product-text text-center" style={{ breakInside: "avoid" }}>
                                    {Math.floor(isInvoiceQuote ? item?.quantity : (item.qty ?? item?.quantity))}
                                  </td>
                                )}
                                {product_details?.SKU && !showSKU && (
                                  <td className="table-product-sku-size product-text hide-at-tab hide-at-tab2 " style={{ breakInside: "avoid" }}>
                                    {showAlternateName ? item?.product?.id || item.id : item.product?.sku || item?.sku}
                                  </td>
                                )}
                                {product_details?.UPC_Number && !showSKU && (
                                  <td className="table-product-upc-col product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {getSelectedUnitUpc(item)}
                                  </td>
                                )}
                                {(product_details?.RETAIL_UPC ?? true) && !showSKU && (
                                  <td className="table-product-upc-col product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {item.product?.retail_upc1 || item?.retail_upc1 || ""}
                                  </td>
                                )}
                                {product_details?.UPC_Barcode && !showBarcode && (
                                  <td className="table-product-barcode-col" style={{ breakInside: "avoid" }}>
                                    {(item.product?.upc || item?.upc) && (
                                      <Barcode
                                        value={product_details?.["barcode_on_uom"] === BarcodeOnUOM.SOLD_BY_UOM && item?.product?.unit_prices?.find((unitPrice) => unitPrice.unit === item?.unit)?.upc ? item.product.unit_prices.find((unitPrice) => unitPrice.unit === item?.unit).upc  : item.product?.upc || item?.upc}
                                        displayValue={false}
                                        height={25}
                                        background={key % 2 == 0 ? "#ecf0f3" : "#fff"}
                                      />
                                    )}
                                  </td>
                                )}
                                {product_details?.Unit && (
                                  <td className="table-product-qty-size product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {unitLabel(item.unit, item?.unit_name)}
                                  </td>
                                )}
                                {isReturned && product_details?.return_to_stock && (
                                  <td className="table-product-price-size product-text" style={{ breakInside: "avoid" }}>
                                    {getSaleReturnStatusType(item?.return_to_stock)}
                                  </td>
                                )}
                                {product_details?.Supply_Price && !showPrice && (
                                  <td className="table-product-price-size product-text" style={{ breakInside: "avoid" }}>
                                    {currencySymbol}
                                    {formatCurrencyCustom(item?.newPrice || item.unit_price)}
                                    {(isPromotionPrice(item)) && (
                                    <div style={{ textDecoration: 'line-through' }}>
                                      {product_details.strike_through ? `${currencySymbol}${formatCurrencyCustom(item?.preferred_price)}` : null}
                                    </div>
                                    )}
                                  </td>
                                )}
                                {product_details?.Net_Sale_Price && !showPrice && (
                                  <td className="table-product-price-size product-text" style={{ breakInside: "avoid" }}>
                                    {currencySymbol}
                                    {item?.qty || item?.quantity
                                      ? formatCurrencyCustomThree(
                                          (item?.newPrice || item.unit_price) +
                                            taxValues?.map(({ amount }) => amount).reduce((total, amount) => total + amount, 0) / (item?.qty || item?.quantity)
                                        )
                                      : `0.00`}
                                    {/* {formatCurrencyCustom((item?.newPrice || item.unit_price))} */}
                                  </td>
                                )}
                                {product_details?.msrp_price && !showMsrp && (
                                  <td className="table-product-price-size product-text" style={{ breakInside: "avoid" }}>
                                    {currencySymbol}
                                    {formatCurrencyCustom(item?.msrp_price)}
                                  </td>
                                )}
                                {product_details?.Discount && (
                                  <td className="table-product-other-size product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {item?.discount_type == DISCOUNT_TYPE.FIXED ? currencySymbol : ""}
                                    {item?.discount ? item?.discount : 0}
                                    {item?.discount_type == DISCOUNT_TYPE.PERCENTAGE ? "%" : ""}
                                  </td>
                                )}
                                {product_details?.Delivered_Quantity &&
                                  ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                                  [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(
                                    order.status
                                  ) && (
                                    <td className="table-product-qty-size product-text" style={{ textAlign: "center" }}>
                                      {item.delivered_qty}
                                    </td>
                                  )}
                                {product_details?.Remaining_Quantity &&
                                  ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                                  [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(
                                    order.status
                                  ) && (
                                    <td className="table-product-qty-size product-text" style={{ textAlign: "center" }}>
                                      {item.qty - item.delivered_qty}
                                    </td>
                                  )}
                                {product_details?.Taxes && (
                                  <td className="table-product-other-size product-text hide-at-tab hide-at-tab2" style={{ breakInside: "avoid" }}>
                                    {currencySymbol}
                                    {(item?.qty || item?.quantity) && taxValues?.length
                                      ? formatCurrencyCustomThree(taxValues?.map(({ amount }) => amount).reduce((total, amount) => total + amount, 0))
                                      : 0}
                                  </td>
                                )}
                                {/* Split Tax Cells */}
                                {product_details?.Split_Taxes &&
                                  uniqueTaxTypes.map((taxType, index) => {
                                    const taxAmount = taxValues?.find(({ tax }) => tax?.name === taxType)?.amount || 0;
                                    return (
                                      <td
                                        key={`tax-cell-${index}`}
                                        className="table-product-other-size product-text hide-at-tab hide-at-tab2"
                                        style={{ breakInside: "avoid" }}
                                      >
                                        {taxAmount > 0 ? `${currencySymbol}${formatCurrencyCustomThree(taxAmount)}` : "-"}
                                      </td>
                                    );
                                  })}
                                {(product_details?.Total_Without_Discount || product_details?.Extended) && !showExtCost && (
                                  <td className="table-product-other-size align-center product-text" style={{ breakInside: "avoid" }}>
                                    {currencySymbol}
                                    {formatCurrencyCustom(getItemTotal(item, taxValues, product_details?.Total_Without_Discount)).toLocaleString()}
                                  </td>
                                )}
                                {/* sale_price - discount + tax */}
                              </tr>
                            ) : (
                              <tr
                                key={"item" + item?.id + item?.name}
                                className={`back-order-row ${
                                  ![ORDER_STATUS.COMPLETED.value, ORDER_STATUS.EXECUTED.value].includes(order.status) &&
                                  item?.product?.transferable_qty === 0 &&
                                  item?.product?.back_order_portal
                                    ? "pink-background"
                                    : "white-background"
                                }`}
                                style={{
                                  breakInside: "avoid",
                                }}
                              >
                                {orderedVisibleTabFields
                                  .map((field) => {
                                    if (field.id === "sr-no") {
                                      globalIndex++;
                                    }
                                    return renderTableCell(field, item, taxValues);
                                  })
                                  .filter(Boolean)}
                              </tr>
                            )}
                            {!showTaxes ? (
                              <>
                                {product_details.Tax_notes && taxValues?.length > 0 ? (
                                  <tr>
                                    <td colSpan={isInvoiceThemeTypeEnabled == "theme1" ? getTotalColumnCount() : getTheme2TotalColumnCount()} style={{ width: "100%" }}>
                                      <b>Taxes:</b>{" "}
                                      {taxValues?.map(
                                        ({ tax: { name }, tax_attribute: { name: taxAttributeName, id: taxAttributeId }, value, amount }, key) => {
                                          const TaxAttributeOnDisplay = `${name} ${currencySymbol}${formatCurrencyCustomThree(amount)} @ ${![CONSTANT_ATTRIBUTE.COST_PRICE, CONSTANT_ATTRIBUTE.SALE_PRICE].includes(taxAttributeName?.toLowerCase()) ? currencySymbol : ""}${value}${[CONSTANT_ATTRIBUTE.COST_PRICE, CONSTANT_ATTRIBUTE.SALE_PRICE].includes(taxAttributeName?.toLowerCase()) ? "%" : ""}  / ${taxAttributeName}${taxValues?.length == key + 1 ? "" : ","} `;
                                          return value ? TaxAttributeOnDisplay : "";
                                        }
                                      )}
                                    </td>
                                  </tr>
                                ) : null}
                              </>
                            ) : null}
                            {(product_details.Invoice_memo && item?.note && order?.sale_type != 2) || (product_details.unit_notes && item.product?.product_unit_description) ? (
                              <tr>
                                <td colSpan={isInvoiceThemeTypeEnabled == "theme1" ? getTotalColumnCount() : getTheme2TotalColumnCount()} style={{ width: "100%" }}>
                                  {product_details.Invoice_memo && item?.note && order?.sale_type != 2 && (
                                    <span>
                                      <b>Note: </b>
                                      {item?.note}
                                    </span>
                                  )}
                                  {product_details.Invoice_memo && item?.note && order?.sale_type != 2 && product_details.unit_notes && item.product?.product_unit_description && (
                                    <span> </span>
                                  )}
                                  {product_details.unit_notes && item.product?.product_unit_description && (
                                    <span>
                                      <b>Unit Notes: </b>
                                      {item.product?.product_unit_description}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ) : null}
                          </>
                        );
                      })}
                      {product_details?.Parent_Category ||
                      !Object.hasOwn(product_details, "Parent_Category") ||
                      product_details?.Total_Qty ||
                      !Object.hasOwn(product_details, "Total_Qty") ? (
                        <tr style={{ backgroundColor: "#e7e7e7" }}>
                          <td colSpan={isInvoiceThemeTypeEnabled == "theme1" ? getTotalColumnCount() : getTheme2TotalColumnCount()} className="align-left cat-size total_category" style={{ padding: "0px 10px 0px 100px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                              {/* Left side - Category Name */}
                              <div>
                                {(product_details?.Parent_Category || !Object.hasOwn(product_details, "Parent_Category")) && (
                                  <strong>
                                    {`${items === "Misc_Items" ? "Misc. item(s)" : ""} ${items.charAt(0).toUpperCase() + items.slice(1)}`}
                                    {filteredProducts[items].categoriesAssociated.length ? (
                                      <span> ({filteredProducts[items].categoriesAssociated.join(", ")})</span>
                                    ) : null}
                                  </strong>
                                )}
                              </div>

                              {/* Right side - Qty and Total */}
                              <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
                                {(product_details?.Total_Qty || !Object.hasOwn(product_details, "Total_Qty")) && (
                                  <strong>
                                    <span style={{ marginLeft: "0.5em" }}>Qty:</span> <span>{filteredQuantity[items]}</span>
                                  </strong>
                                )}
                                {(product_details?.Total_Without_Discount || product_details?.Extended) && !showExtCost && (
                                  <strong>
                                    Total: {currencySymbol}
                                    {formatCurrencyCustom(filteredProducts[items]?.extendedPrice)}
                                  </strong>
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : null}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            ) : null}
            <div className="hide-invoice-card">
              {Object.keys(filteredProducts)?.map((items, key) => (
                <Row gutter={[20, 20]} key={key}>
                  {" "}
                  {/* Add gutter for spacing */}
                  {filteredProducts[items].products
                    .sort((a, b) => {
                      const nameA = a.product?.name?.toUpperCase() || "";
                      const nameB = b.product?.name?.toUpperCase() || "";
                      return nameA.localeCompare(nameB);
                    })
                    .map((item, index) => (
                      <ColAnt xs={24} sm={6} key={index}>
                        <Card
                          style={{
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "7px",
                            padding: "3px",
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <>
                              {product_details?.Image && !showImage && (
                                <div style={{ marginRight: "10px" }}>
                                  {item.product?.images?.[0] || item?.images?.[0] ? (
                                    <img
                                      alt={item.product?.name || "Product"}
                                      src={item.product?.images?.[0] || item?.images?.[0]}
                                      style={{ height: 100, objectFit: "cover", width: "100px" }}
                                    />
                                  ) : null}
                                </div>
                              )}
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <div>
                                  {product_details?.Name && (
                                    <>
                                      <p style={{ fontSize: "12px", fontWeight: "500", color: "black" }}>{item.product?.name || item?.name}</p>
                                      <ProductLabels tags={item.product?.tags || item.tags} screen="invoice" />
                                    </>
                                  )}
                                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                    <div style={{ display: "flex", flexDirection: "column", lineHeight: "5px" }}>
                                      {product_details?.Supply_Price && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>
                                          Price: {currencySymbol}
                                          {formatCurrencyCustom(item?.newPrice || item.unit_price)}
                                        </p>
                                      )}
                                      {product_details?.SKU && !showSKU && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>SKU: {item.product?.sku || item?.sku}</p>
                                      )}
                                      {product_details?.UPC_Number && !showSKU && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>UPC: {getSelectedUnitUpc(item)}</p>
                                      )}
                                      {(product_details?.Total_Without_Discount || product_details?.Extended) && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>
                                          Total: {currencySymbol}
                                          {formatCurrencyCustom(getItemTotal(item, [], product_details?.Total_Without_Discount)).toLocaleString()}
                                        </p>
                                      )}
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", lineHeight: "5px" }}>
                                      {product_details?.Discount && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>
                                          Disc.: {item?.discount_type == DISCOUNT_TYPE.FIXED ? currencySymbol : ""}
                                          {item?.discount ? item?.discount : 0}
                                          {item?.discount_type == DISCOUNT_TYPE.PERCENTAGE ? "%" : ""}
                                        </p>
                                      )}
                                      {product_details?.Qty && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>
                                          Sold Qty: {Math.floor(isInvoiceQuote ? item?.quantity : (item.qty ?? item?.quantity))}
                                        </p>
                                      )}
                                      {product_details?.Delivered_Quantity &&
                                        ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                                        [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(
                                          order.status
                                        ) && <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>Delivered Qty: {item.delivered_qty}</p>}
                                      {product_details?.Remaining_Quantity &&
                                        ![ORDER_STATUS.PENDING.value, ORDER_STATUS.EXECUTED.value, ORDER_STATUS.COMPLETED.value].includes(order.status) &&
                                        [ORDER_STATUS.PARTIALLY_RETURNED.value, ORDER_STATUS.PARTIALLY_EXECUTED.value, ORDER_STATUS.RETURNED.value].includes(
                                          order.status
                                        ) && (
                                          <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>Remaining Qty: {item.qty - item.delivered_qty}</p>
                                        )}
                                      {product_details?.Unit && (
                                        <p style={{ fontSize: "10px", color: "black", lineHeight: "10px" }}>Unit: {unitLabel(item.unit, item?.unit_name)}</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                {product_details?.UPC_Barcode && !showBarcode && (item.product?.upc || item?.upc) && (
                                  <div style={{ width: "175px" }}>
                                    <Barcode
                                      value={item.product?.upc ? item.product?.upc : item?.upc}
                                      displayValue={false}
                                      height={15}
                                      width={1}
                                      background={key % 2 === 0 ? "#ecf0f3" : "#fff"}
                                    />
                                  </div>
                                )}
                              </div>
                            </>
                          </div>
                        </Card>
                      </ColAnt>
                    ))}
                </Row>
              ))}
            </div>
          </div>
        ) : (
          ""
        )}
        {(() => {
          const hasPayments = showPaymentSection && order.invoice.payments?.length > 0;
          const hasPreferredPaymentMethod = showPreferredPaymentMethod && order?.customer?.preferred_payment_method != null;
          return hasPayments || hasPreferredPaymentMethod ? (
            <>
              <p style={{ fontWeight: "bold", display: "flex", justifyContent: "space-between", margin: "0", padding: "0" }} className="mt-12">
                <p style={{ margin: "0px", padding: "0px" }}>Payment Details</p>
                {hasPayments && showPaymentTerms ? <p style={{ margin: "0px", padding: "0px" }}>
                  Payment Terms:
                  {!customerCreditCheck ? (
                    order.sale_type === 1 && payment_detials?.AGING_TYPE ? (
                      calculateDays(order.invoice.due_date, order.order_date) !== 0 ? (
                        <span className="text hide-at-mobile">{`${calculateDays(order.invoice.due_date, order.order_date)} Days`}</span>
                      ) : (
                        <span className="text hide-at-mobile">{_AGING_TYPE.DueImmediately?.name}</span>
                      )
                    ) : (
                      <span></span>
                    )
                  ) : (
                    <span></span>
                  )}
                </p> : null}
              </p>
              {hasPreferredPaymentMethod ? (
                <p style={{ fontWeight: "bold", margin: "0", padding: "0" }} className="mt-1">
                  Pref. Payment Method:{" "}
                  <span className="text hide-at-mobile">{getNameByValue(order?.customer?.preferred_payment_method, PREFERRED_PAYMENT_METHOD)}</span>
                </p>
              ) : null}
            </>
          ) : null;
        })()}
        {showPaymentSection && payments?.length > 0 ? (
          <table className="items-table table-size mb-5">
            <thead className="table-active">
              <tr>
                {isInvoiceThemeTypeEnabled === "theme1" ? (
                  <>
                    {showPaymentSerialNo ? <th className="second-subheading hide-at-tab">No.</th> : null}
                    {showPaymentType ? <th className="second-subheading ">Payment Type / Sub Type</th> : null}
                    {showPaymentReferenceNo ? <th className="second-subheading hide-at-mobile">Ref. No. / Cheque No.</th> : null}
                    {showPaymentId ? <th className="second-subheading hide-at-mobile">Payment ID</th> : null}
                    {showPaymentDate ? <th className="second-subheading hide-at-mobile">Payment Date</th> : null}
                    {showPaymentAmount ? <th className="second-subheading">Payment Amount</th> : null}
                    {showPaymentAppliedAmount ? <th className="second-subheading">Applied Amount</th> : null}
                    {showPaymentStatus ? <th className="second-subheading">Status</th> : null}
                  </>
                ) : (
                  <>{visiblePaymentTabFields.map((field) => renderPaymentTableHeader(field)).filter(Boolean)}</>
                )}
              </tr>
            </thead>
            <tbody>
              {order.invoice.payments.filter(({payment_type})=>order.sale_type!==SALE_TYPE.SALE_ORDER.value || payment_type !== PAYMENT_TYPE_SALE_ORDER.CUSTOMER_CREDIT_ADDED.value ).map((item, idx) => ( // not showing customer credit added payment in invoice
                <>
                  {![5, 6, 8].includes(item?.status) ? (
                    <tr>
                      {isInvoiceThemeTypeEnabled === "theme1" ? (
                        <>
                          {showPaymentSerialNo ? (
                            <td className="text hide-at-tab">
                              {/*{Object.keys(PAYMENT_TYPE_SALE_ORDER).map((salePayment) => {*/}
                              {/*  if (PAYMENT_TYPE_SALE_ORDER[salePayment].value == item.payment_type)*/}
                              {/*    return PAYMENT_TYPE_SALE_ORDER[salePayment].type == "Customer Credit Added" ? null : (item?.parent?.no || "");*/}
                              {/*})}*/}
                                {idx + 1}
                            </td>
                          ) : null}
                         {showPaymentType ? <td className="product-text">
                            {Object.keys(PAYMENT_TYPE_SALE_ORDER).map((salePayment) => {
                              if (PAYMENT_TYPE_SALE_ORDER[salePayment].value === item?.parent?.payment_type||item.payment_type === PAYMENT_TYPE_SALE_ORDER[salePayment].value) {
                                const isCustomerCreditAdded = PAYMENT_TYPE_SALE_ORDER[salePayment].type === PAYMENT_TYPE_SALE_ORDER.CUSTOMER_CREDIT_ADDED.type;
                                customerCreditCheck = isCustomerCreditAdded;

                                const paymentSubTypeLabel = getPaymentSubTypeLabel(item?.parent?.payment_type||item.payment_type);

                                return (
                                  <span
                                    style={{
                                      fontSize: isCustomerCreditAdded ? "fontsize-8" : "inherit",
                                      fontStyle: isCustomerCreditAdded ? "italic" : "normal",
                                    }}
                                  >
                                    {isCustomerCreditAdded ? (
                                      `- ${PAYMENT_TYPE_SALE_ORDER[salePayment].type}`
                                    ) : (
                                      <>
                                        {PAYMENT_TYPE_SALE_ORDER[salePayment].type}
                                        {(PAYMENT_TYPE_SALE_ORDER[salePayment].type === "Credit/Debit Card" ||
                                          PAYMENT_TYPE_SALE_ORDER[salePayment].type === "Cheque") &&
                                          paymentSubTypeLabel &&
                                          ` / ${paymentSubTypeLabel}`}
                                      </>
                                    )}
                                  </span>
                                );
                              }
                            })}
                          </td> : null}
                          {showPaymentReferenceNo ? <td className="product-text hide-at-mobile">{item?.reference_number || item?.no}</td> : null}
                          {showPaymentId ? <td className="product-text hide-at-mobile">{item.no || ""}</td> : null}
                          {showPaymentDate ? (
                            <td className="product-text hide-at-mobile">{formatDate(getTimeByTimeZone(timezone, getPaymentDisplayDate(item)))}</td>
                          ) : null}
                          {showPaymentAmount ? <td className="product-text">{currencySymbol}{item?.paid_amount || "0"}</td> : null}
                          {showPaymentAppliedAmount ? <td className="product-text">{currencySymbol}{item?.applied_amount || "0"}</td> : null}
                          {/* {showPaymentCreditAmount ? <td className="product-text">{currencySymbol}{item?.remaining_amount || "0"}</td> : null} */}
                          {showPaymentStatus ? <td className="product-text">{getPaymentStatusName(item.status) || ""}</td> : null}
                        </>
                      ) : (
                        <>{visiblePaymentTabFields.map((field) => renderPaymentTableCell(field, item, idx)).filter(Boolean)}</>
                      )}
                    </tr>
                  ) : null}
                  {/*{![5, 6, 8].includes(item?.status) && item?.distributed_amount > 0 ? (*/}
                  {/*  <b> {`- amount applied to other invoices: ($${item?.distributed_amount})`}</b>*/}
                  {/*) : (*/}
                  {/*  ""*/}
                  {/*)}*/}
                </>
              ))}
            </tbody>
          </table>
        ) : null}

        {!!(total_amount_details.show_shipment_details && order.shipment_tracking?.length) ? (
          <>
            <p style={{ fontWeight: "bold" }} className="mt-12">
              {" "}
              Shipment Details{" "}
            </p>
            <table className="items-table table-size mb-5">
              <thead className="table-active">
                <tr>
                  <th className="second-subheading hide-at-tab"> No</th>
                  <th className="second-subheading ">Date</th>
                  <th className="second-subheading ">Tracking IDs</th>
                  <th className="second-subheading hide-at-mobile">Carrier</th>
                  <th className="second-subheading hide-at-mobile">No. of Items</th>
                  <th className="second-subheading">No. of Boxes</th>
                  <th className="second-subheading">Approx. Weight</th>
                </tr>
              </thead>
              <tbody>
                {order.shipment_tracking.map((item, idx) => (
                  <tr>
                    <td className="text hide-at-tab"> {idx + 1}</td>
                    <td className="product-text">{item.ship_date}</td>
                    <td className="product-text">{item.tracking_ids.join(", ") || "N/A"}</td>
                    <td className="product-text hide-at-mobile">{item.carrier || "N/A"}</td>
                    <td className="product-text hide-at-mobile">{item.items || "N/A"}</td>
                    <td className="product-text">{item.boxes || "N/A"}</td>
                    <td className="product-text">
                      {item.weight || "N/A"} {WEIGHT_UNIT_EXPORT[item.weight_unit] || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : null}
        {!!order?.sale_return?.id ? (
          <div className="products">
            <table
              className="items-table table-size table-striped"
              width="100%"
              style={{ pageBreakInside: "avoid", pageBreakBefore: "always", minHeight: "100%", pageBreakAfter: "always" }}
            >
              <thead>
                <tr>
                  <th className="table-product-name-size subheading">Name</th>
                  <th className="table-product-sku-size subheading">SKU / UPC</th>
                  <th className="table-product-other-size subheading">Price </th>
                  <th className="table-product-other-size subheading">Discount</th>
                  <th className="table-product-qty-size subheading">Return Qty</th>
                  <th className="table-product-other-size subheading text-center">Total</th>
                </tr>
              </thead>
              <tbody>
                {order.sale_return.sale_return_details.map((item) => (
                  <tr>
                    <td className="table-product-name-size product-text">{item?.product?.name}<ProductLabels tags={item.product?.tags} screen="invoice" /></td>
                    <td className="table-product-sku-size product-text">
                      {item.product.sku}
                      {getSelectedUnitUpc(item) ? ` / ${getSelectedUnitUpc(item)}` : ""}
                    </td>
                    <td className="table-product-other-size product-text">
                      {currencySymbol}
                      {formatCurrencyCustom(item.unit_price)}
                    </td>
                    <td className="table-product-other-size product-text">
                      {item?.discount_type == DISCOUNT_TYPE.FIXED ? currencySymbol : ""}
                      {item?.discount ? item?.discount : 0}
                      {item?.discount_type == DISCOUNT_TYPE.PERCENTAGE ? "%" : ""}
                    </td>
                    <td className="table-product-qty-size product-text">{item.qty}</td>
                    <td className="table-product-other-size product-text">
                      {item?.discount_type == DISCOUNT_TYPE.FIXED
                        ? formatCurrencyCustom((item.unit_price - item?.discount) * item.qty)?.toLocaleString()
                        : formatCurrencyCustom(item.unit_price * item.qty - (item.unit_price * item.qty * item?.discount) / 100)?.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}

        {/* This logic to show summary detail of Invoice wes developed earliear so for the time being I am just setting it into responsive */}
        <div>
          <table width="100%" className="float-right invoice-summary-details">
            {/* <div className="row mt-2"> */}
            <Row>
              <Col sm={6} lg={6} md={12}>
                <table className="empty-table-for-invoiceSummary">
                  <tbody>
                    {stampType != "quote" && total_amount_details.Show_tax_breakdown ? (
                      order.sale_order_level_taxes.length > 0 || order.sale_order_li_total_taxes.length > 0 ? (
                        <tr>
                          <td>
                            <div>
                              <h4 className="ml-7">Taxes</h4>
                              <ul style={{ listStyleType: "none" }}>
                                {order.sale_order_level_taxes?.length > 0
                                  ? order.sale_order_level_taxes?.map(({ tax: { name }, amount, value }) => {
                                      return <ShowFlatTaxes name={name} amount={amount} />;
                                    })
                                  : null}

                                {order.sale_order_li_total_taxes?.length > 0
                                  ? order.sale_order_li_total_taxes?.map(({ tax: { name }, amount }) => {
                                      return <ShowFlatTaxes name={name} amount={amount} />;
                                    })
                                  : null}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ) : null
                    ) : null}
                    <tr>
                      <div className="third-subheading message-body hide-at-mobile">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: tenantInvoiceDescription,
                          }}
                        />
                        <br />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: tanantData.footer_message,
                          }}
                        />
                        {/* {tanantData.company_message} */}
                        {!signature_align_right && product_details?.Signature_On_Invoice ? (
                          <div className="d-flex justify-content-start">
                            <div className="font-right mb-5" style={{ marginTop: "10px" }}>
                              Name & Signature: ____________________
                            </div>
                          </div>
                        ) : null}
                        <p className="powered-by" style={{ marginTop: "10px", textAlign: "left", width: "100%", boxSizing: "border-box" }}>
                          {hideInvoiceHeader ? null : "Powered by Kommerce Hub."}
                        </p>
                      </div>
                    </tr>
                  </tbody>
                </table>
              </Col>
              <Col sm={6} lg={6} md={12} className="d-flex justify-content-end">
                <table>
                  <tbody>
                    {SALE_INVOICE_TYPE.RETURN.value !== invoiceType && (
                      <>
                        {total_amount_details?.Total_Products ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_product_bold ? "second-subheading" : ""}>Total Products</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_total_product_bold ? "second-subheading" : ""}`}>
                              {visibleInvoiceProductCount}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.Total_Quantity ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_quantity_bold ? "second-subheading" : ""}>Total Quantity</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_total_quantity_bold ? "second-subheading" : ""}`}>
                              {visibleInvoiceQuantity}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.Sub_Total && !showPrice ? (
                          <tr>
                            <td className={total_amount_details?.summary_sub_total_bold ? "second-subheading" : ""}>Sub Total</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_sub_total_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(subtotal?.() ?? order?.invoice?.sub_total).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                        {order?.discount && order?.discount > 0 ? (
                          <>
                            {total_amount_details?.Other_Discount && (
                              <tr>
                                <td className={total_amount_details?.summary_other_discount_bold ? "second-subheading" : ""}>Additional Discount</td>
                                <td className={`product-text font-right ${total_amount_details?.summary_other_discount_bold ? "second-subheading" : ""}`}>
                                  {order?.discount_type == DISCOUNT_TYPE.FIXED ? currencySymbol : ""}
                                  {order?.discount}
                                  {order?.discount_type == DISCOUNT_TYPE.PERCENTAGE ? "%" : ""}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : null}

                        {order.invoice.total_discount > 0 ? (
                          <>
                            {total_amount_details?.Discount_Amount && (
                              <tr>
                                <td className={total_amount_details?.summary_discount_amount_bold ? "second-subheading" : ""}>Discount Amount</td>
                                <td className={`product-text font-right ${total_amount_details?.summary_discount_amount_bold ? "second-subheading" : ""}`}>
                                  {currencySymbol}
                                  {formatCurrencyCustom(order.invoice.total_discount).toLocaleString()}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : null}

                        {(order.sale_order_level_taxes?.length > 0 || order.sale_order_li_total_taxes?.length > 0) &&
                        SALE_INVOICE_TYPE.RETURN.value !== invoiceType ? (
                          <>
                            {total_amount_details?.Tax && (
                              <tr>
                                <td className={total_amount_details?.summary_tax_bold ? "second-subheading" : ""}>Tax</td>
                                <td className={`product-text font-right ${total_amount_details?.summary_tax_bold ? "second-subheading" : ""}`}>
                                  {currencySymbol}
                                  {formatCurrencyCustomThree(order.tax_amount)}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : null}

                        {order.delivery_charges > 0 ? (
                          <>
                            {total_amount_details?.Delivery_Charges && (
                              <tr>
                                <td className={total_amount_details?.summary_delivery_charges_bold ? "second-subheading" : ""}>Delivery Charges</td>
                                <td className={`product-text font-right ${total_amount_details?.summary_delivery_charges_bold ? "second-subheading" : ""}`}>
                                  {currencySymbol}{formatCurrencyCustom(order.delivery_charges).toLocaleString()}
                                </td>
                              </tr>
                            )}
                          </>
                        ) : null}

                        {total_amount_details?.total_amount && !total_amount_details?.total_amount_without_discount && !showPrice ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_amount_bold ? "second-subheading" : ""}>Invoice Total</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_total_amount_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.invoice?.total_amount).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                        {total_amount_details?.total_amount_without_discount && !showPrice ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_amount_without_discount_bold ? "second-subheading" : ""}>Invoice Total</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_total_amount_without_discount_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.invoice?.total_amount + (order?.invoice?.total_discount ?? 0)).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                        {total_amount_details?.paid_amount && !showPrice ? (
                          <tr>
                            <td className={total_amount_details?.summary_paid_amount_bold ? "second-subheading" : ""}>Paid Amount</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_paid_amount_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatWithDeci(order?.invoice?.paid_amount).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.remaining_amount && !showCustomerBalance ? (
                          <tr>
                            <td className={total_amount_details?.summary_remaining_amount_bold ? "second-subheading" : ""}>Invoice Balance</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_remaining_amount_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.invoice?.remaining_amount).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                        {total_amount_details?.prev_customer_balance && !showCustomerBalance ? (
                          <tr>
                            <td className={total_amount_details?.summary_prev_customer_balance_bold ? "second-subheading" : ""}>Prev. Customer Balance</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_prev_customer_balance_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.pre_order_customer_balance).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.total_customer_balance && !showCustomerBalance ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_customer_balance_bold ? "second-subheading" : ""}>
                              Total Customer Balance {`(${getTimeByTimeZone(timezone, order.order_date)?.split("T")[0]})`}
                            </td>
                            <td className={`product-text font-right ${total_amount_details?.summary_total_customer_balance_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.post_order_customer_balance).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                        {total_amount_details?.curr_customer_balance ? (
                          <tr>
                            <td className={total_amount_details?.summary_current_customer_balance_bold ? "second-subheading" : ""}>Current Customer Balance</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_current_customer_balance_bold ? "second-subheading" : ""}`}>
                              {currencySymbol}
                              {formatCurrencyCustom(order?.customer?.balance).toLocaleString()}
                            </td>
                          </tr>
                        ) : null}

                          {total_amount_details?.Wallet_balance && !showCustomerBalance && stampType !== "quote"  && (
                              <tr>
                                  <td className={total_amount_details?.summary_wallet_balance_bold ? "second-subheading" : ""}>Wallet Balance</td>
                                  <td className={`product-text font-right ${total_amount_details?.summary_wallet_balance_bold ? "second-subheading" : ""}`}>
                                      {/* <strong> */}
                                      {currencySymbol}
                                      {formatCurrencyCustom(order?.customer?.wallet_balance).toLocaleString()}
                                      {/* </strong> */}
                                  </td>
                              </tr>
                          )}
                      </>
                    )}
                    {SALE_INVOICE_TYPE.RETURN.value === invoiceType ? (
                      <>
                        {total_amount_details?.Total_Products ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_product_bold ? "second-subheading" : ""}>Total Products</td>
                            <td className={`product-text float-right ${total_amount_details?.summary_total_product_bold ? "second-subheading" : ""}`}>
                              {visibleInvoiceProductCount + (order.sale_return.sale_return_details?.length || 0)}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.Total_Quantity ? (
                          <tr>
                            <td className={total_amount_details?.summary_total_quantity_bold ? "second-subheading" : ""}>Total Quantity</td>
                            <td className={`product-text float-right {total_amount_details?.summary_total_quantity_bold ? "second-subheading" : ""}`}>
                              {visibleInvoiceQuantity}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.Returned_Quantity ? (
                          <tr>
                            <td className={total_amount_details?.summary_returning_quantity_bold ? "second-subheading" : ""}>Returned Quantity</td>
                            <td className={`product-text float-right ${total_amount_details?.summary_returning_quantity_bold ? "second-subheading" : ""}`}>
                              {order.sale_order_details.reduce((sum, product) => sum + product.qty, 0)}
                            </td>
                          </tr>
                        ) : null}
                        {total_amount_details?.Amount_Returned ? (
                          <tr>
                            <td className={total_amount_details?.summary_amount_returned_bold ? "second-subheading" : ""}>Amount Returned</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_amount_returned_bold ? "second-subheading" : ""}`}>
                              <strong>
                                ({currencySymbol}
                                {formatCurrencyCustom(
                                  order.sale_order_details.reduce((total, product) => total + product.unit_price * product.qty, 0)
                                ).toLocaleString()}
                                )
                              </strong>
                            </td>
                          </tr>
                        ) : null}
                      </>
                    ) : null}
                    {order.coupon?.discount && order.coupon?.discount > 0 ? (
                      <>
                        {total_amount_details?.Coupon_Discount ? (
                          <tr>
                            <td className={total_amount_details?.summary_coupon_discount_bold ? "second-subheading" : ""}>Coupon Discount</td>
                            <td className={`product-text font-right ${total_amount_details?.summary_coupon_discount_bold ? "second-subheading" : ""}`}>
                              {order.coupon?.discount}%
                            </td>
                          </tr>
                        ) : null}
                      </>
                    ) : null}
                    <tr>
                      <td>
                        <br />
                      </td>
                      <td>
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
              {signature_align_right && product_details?.Signature_On_Invoice && (
                <div className="d-flex justify-content-end" style={{ width: "100%" }}>
                  <div className="font-right mb-5"> Name & Signature: ____________________</div>
                </div>
              )}
            </Row>
            {/* </div> */}
          </table>
        </div>
        <div className="footer-quote mt-10" style={{ breakInside: "avoid" }}>
          {total_amount_details.show_saved_amount_toggle && (
            <>
              {order?.customer?.tier_id && order?.sale_type === 1 && (order?.saved_amount > 0 || order?.discount > 0) ? (
                <div className="savedAmount" style={{ textAlign: "center", fontWeight: "bold" }}>
                  You have saved{" "}
                  <span style={{ color: "green" }}>
                    {" "}
                    {currencySymbol}
                    {formatCurrencyCustom(
                      calculateSaleDiscount(order.sale_order_details, order.discount, order.discount_type) + order.saved_amount
                    ).toLocaleString()}
                  </span>{" "}
                  on this sale order. Thanks for shopping and being a loyal customer!
                </div>
              ) : order?.customer?.id && order?.sale_type === 1 && (order?.saved_amount > 0 || order?.discount > 0) ? (
                <div className="savedAmount" style={{ textAlign: "center", fontWeight: "bold" }}>
                  {" "}
                  You Saved{" "}
                  <span style={{ color: "red" }}>
                    {currencySymbol}
                    {formatCurrencyCustom(
                      calculateSaleDiscount(order.sale_order_details, order.discount, order.discount_type) + order.saved_amount
                    ).toLocaleString()}
                  </span>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        <div className="third-subheading message-body hide-invoice-card">
          {tanantData.dist_message}
          <br />
          {/* {tanantData.company_message} */}
          {hideInvoiceHeader ? null : "Powered by Kommerce Hub."}
        </div>
        {showAddPaymentModal ? <AddPaymentModal show={showAddPaymentModal} handleClose={handleClosePamentModal} order={order} /> : null}
      </div>
    );
  } else {
    return null;
  }
}
